<template lang="pug">
  #contract-changes
    b-card(header-tag="header")
      b-container.white-space(fluid="fluid")
        template(v-if="isLoading === true")
          loading(:height="200")
        template(v-else)
          b-form-group(v-if="is_direct_sales === false")
            b-form-text.ml-3 ※ご契約ユーザー数の変更に伴い、サービスの一時停止が発生する場合があります。
            b-form-text.ml-3.mb-3 ※変更お申し込みいただいている場合、表示されている内容と実際の環境が一致しないことがあります。
          b-form-group(v-else)
            b-form-text.ml-3 ※ご契約ユーザー数の変更に伴い、サービスの一時停止が発生する場合があります。
            b-form-text.ml-3 ※年額（12ヶ月支払い）で契約されているお客様は、契約期間途中で契約ユーザーを減らす場合、既にお支払いいただいている費用を返金することはできませんので予めご了承のほどお願いいたします。
            b-form-text.ml-3 ※変更お申し込みいただいている場合、表示されている内容と実際の環境が一致しないことがあります。
            b-form-text.ml-3
              | ※各商品の定価は
              a(href="https://www.desknets.com/neo/price/", target="_blank") こちら
              | をご確認ください。
            b-form-text.ml-3 ※1日開通の場合は当月課金です。
            b-form-text.ml-3.mb-3
              .text-danger ※年額（12か月支払い）で契約されているお客様のユーザー追加分は、開通日即日で残月数分のご請求が発生いたします。
            app-messages(:errorMessages="error_msg_list.top")
            b-link.float-right(href="https://www.desknets.com/neo/usersupport/cancellation/" , target="_blank", rel="noopener noreferrer") ご解約について
          b-row
            b-col
              template(v-if="plan_info.name !== ''")
                //- desknet's NEO 単体契約（優待など）の場合、ライトプランとして表示する
                h5#plan(:class="plan_title_class")
                  span {{ getPlanName(plan_info.name) }}
                  b-button.ml-2(v-if="is_direct_sales === true", pill, variant="outline-primary", size="sm", @click="changePlan")
                    span プラン変更
                img.ml-3.mb-1(src="@/assets/images/logo_desknetsneo_clear_background.png")
                img.ml-2(v-if="isContainAppSuiteInPlan(plan_info.name)", src="@/assets/images/logo_appsuite.png")
                img.ml-2(v-if="isContainChatLuckInPlan(plan_info.name)", src="@/assets/images/logo_chatluck.png")
                b-form-text(:class="plan_data_class")
                  template(v-if="is_direct_sales === true")
                    b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_plan')")
                      span 変更
                      b-icon(scale=0.7, icon="chevron-double-down")
                  template(v-if="show_plan === false")
                    span {{plan_info.user}} ユーザー
                  template(v-else)
                    .input-div-size
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1 変更後のユーザー数：
                        b-col.px-0
                          .form-inline
                            template(v-if="plan_info.name === 'neo.neo_user'")
                              b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.neo_user", placeholder='（半角数字）', :state="error_msg_list.plan.length === 0 ? null : false")
                            template(v-else)
                              b-form-input.mb-2(size="sm", type="text", v-model="order_info[plan_info.name]", placeholder='（半角数字）', :state="error_msg_list.plan.length === 0 ? null : false")
                            b-form-text.ml-1.mt-0.mb-2 ユーザー
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.plan") {{ error_msg }}
                          b-form-text.mt-0 ※最低契約ユーザー数は5ユーザーです。
                          b-form-text.mt-0 ※ご契約単位は1ユーザー単位です。
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3 ユーザー数の変更は販売店にお問い合わせください。
                b-form-text(style="height: 30px;")

                h4#option_service.font-weight-bold desknet's NEO ご利用オプションサービス

                //- セットプランに AppSuite が含まれている場合、「AppSuite」を非表示にする
                template(v-if="isContainAppSuiteInPlan(plan_info.name) === false")
                  h5(:class="neo_title_class")
                    label(:class="hasContract('neo.' + app_suite_kind) ? 'contracted-icon' : 'un-contracted-icon'") 業務アプリ作成ツール AppSuite
                    b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/appsuite/", target="_blank") 詳細はこちら ＞
                  b-form-text(:class="neo_data_class")
                    template(v-if="is_direct_sales === true")
                      b-button.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_app_suite')")
                        span 変更
                        b-icon(scale=0.7, icon="chevron-double-down")
                    template(v-if="show_app_suite === false")
                      span(v-if="hasContract('neo.' + app_suite_kind) === true") {{ contract_info.neo[app_suite_kind] }} ユーザー
                    template(v-else)
                      .input-div-size
                        b-row
                          b-col.space-col-size
                          b-col
                            b-form-radio-group.mb-3(v-model="selected_radio_list.app_suite")
                              template(v-if="hasContract('neo.' + app_suite_kind) === false")
                                b-form-radio(value='0') 新たに利用を開始する
                              template(v-else)
                                b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                                b-form-radio(value='2') 利用を終了する
                        b-row
                          b-col.space-col-size
                          b-col.px-0.title-col-size
                            b-form-text.text-right.mr-1
                              template(v-if="hasContract('neo.' + app_suite_kind) === true") 変更後の
                              template ユーザー数：
                          b-col.px-0
                            .form-inline
                              b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo[app_suite_kind]", placeholder='（半角数字）', :disabled="selected_radio_list.app_suite === '2'", :state="error_msg_list.app_suite.length === 0 ? null : false")
                              b-form-text.ml-1.mt-0.mb-2 ユーザー
                            div
                              b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.app_suite") {{ error_msg }}
                            b-form-text.description-text-position ※最低契約ユーザー数は5ユーザーから、desknet's NEOの契約ユーザー数までのご契約となります。
                            b-form-text.description-text-position ※ご契約単位は1ユーザー単位です。
                    b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                      span(v-if="hasContract('neo.' + app_suite_kind) === false") 新規契約申し込みは販売店にお問い合わせください。
                      span(v-else) ユーザー数の変更は販売店にお問い合わせください。
                  b-form-text(style="height: 30px;")

                //- ウェブ会議
                h5(:class="neo_title_class")
                  label(:class="hasContract('neo.web_conferencing') ? 'contracted-icon' : 'un-contracted-icon'") desknet's NEO ウェブ会議
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/webmtg/", target="_blank") 詳細はこちら ＞
                b-form-text(:class="neo_data_class")
                  b-button.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_web_conferencing')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  template(v-if="show_web_conferencing === false")
                    label.ml-1.mb-0(v-if="hasContract('neo.web_conferencing') === true") {{ contract_info.neo.web_conferencing }} 会議室
                  template(v-else)
                    .input-div-size
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.web_conferencing")
                            template(v-if="hasContract('neo.web_conferencing') === false")
                              b-form-radio(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-2
                            template(v-if="hasContract('neo.web_conferencing') === true") 変更後の
                            template 会議室数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.web_conferencing", placeholder='（半角数字）', :disabled="selected_radio_list.web_conferencing === '2'", :state="error_msg_list.web_conferencing.length === 0 ? null : false")
                            b-form-text.ml-1.mt-0.mb-2 会議室
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.web_conferencing") {{ error_msg }}
                          b-form-text.description-text-position ※最低契約会議室は1会議室から、最大10会議室までのご契約となります。
                          b-form-text.description-text-position ※ご契約単位は1会議室単位です。
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.web_conferencing') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) 会議室数の変更は販売店にお問い合わせください。
                b-form-text(style="height: 30px;")

                //- desknet's DB
                div(v-if="hasContract('neo.cloud_db_user') === true")
                  h5(:class="neo_title_class")
                    label(class="contracted-icon") Web データベースdesknet's DB
                  b-form-text(:class="neo_data_class")
                    label.ml-1 {{ contract_info.neo.cloud_db_user }} ユーザー
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3 ユーザー数の変更は販売店にお問い合わせください。
                  b-form-text(v-else).ml-3 ユーザー数の変更は
                    a(:href="this.returnOldApplicationFormUrl()", target="_blank") こちら
                    | からお申し込みください
                  b-form-text(style="height: 30px;")

                //- desknet's NEOオプションサービス
                h5#neo_option_service(:class="neo_title_class") オプションサービス
                //- RoomMgr
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_room_mgr')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.room_mgr') === true ? 'contracted-icon' : 'un-contracted-icon'") RoomMgr
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/features/roommgr/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_room_mgr === false")
                    b-row
                      b-col.space-col-size
                      b-col.form-inline
                        b-form-text.mt-0.mb-2(v-if="contract_info.neo.option.room_mgr === true") 利用する
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.room_mgr") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.room_mgr")
                            template(v-if="hasContract('neo.option.room_mgr') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                                b-form-text.description-text-position ※SAML認証との併用はできません。
                                b-form-text.description-text-position ※クライアント認証オプションと併用する場合、RoomMgrへログインするタブレットへ証明書をインストールしていただくか、タブレットからの接続は特定のIPアドレス/ネットワークからとして、クライアント認証を除外する手続きを行ってください。
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='2') 利用を終了する
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.room_mgr') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。

                //- 交通費・経費精算
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_expense_settlement')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.expense_settlement') === true ? 'contracted-icon' : 'un-contracted-icon'") 交通費経費精算
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/releases/v30/feature1.html", target="_blank") 詳細はこちら ＞
                  template(v-if="show_expense_settlement === false")
                    b-row
                      b-col.space-col-size
                      b-col.form-inline
                        b-form-text.mt-0.mb-2(v-if="contract_info.neo.option.expense_settlement === true") 利用する
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.expense_settlement") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.expense_settlement")
                            template(v-if="hasContract('neo.option.expense_settlement') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                                b-form-text.description-text-position ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='2') 利用を終了する
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.expense_settlement') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。

                //- タイムカード+CLOUZA
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_clouza')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.clouza') === true ? 'contracted-icon' : 'un-contracted-icon'") タイムカード＋CLOUZA
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/timecardp/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_clouza === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.mt-0.mb-2(v-if="contract_info.neo.option.clouza.user") ユーザー数 ： {{contract_info.neo.option.clouza.user}} ユーザー
                        b-form-text.text-left(v-if="contract_info.neo.option.clouza.clouza_company") CLOUZAお試し環境からの引き継ぎ ： {{contract_info.neo.option.clouza.clouza_company}}
                        b-form-text.text-left(v-if="contract_info.neo.option.clouza.paid_leave_option === true") 有休管理＋申請承認オプション（10ユーザー¥1,650/月）
                  template(v-else)
                    .input-div-size(v-show="show_clouza")
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.clouza_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.clouza", :state="error_msg_list.clouza_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.option.clouza') === false")
                              b-form-radio(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1
                            template(v-if="hasContract('neo.option.clouza') === true") 変更後の
                            template ユーザー数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.option.clouza.user", placeholder='（半角数字）', :disabled="selected_radio_list.clouza === '2'", :state="error_msg_list.clouza_user.length === 0 ? null : false")
                            b-form-text.ml-1.mt-0.mb-2 ユーザー
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.clouza_user") {{ error_msg }}
                          b-form-text.description-text-position ※最低契約ユーザー数は20ユーザーです。
                          b-form-text.description-text-position ※ご契約単位は10ユーザー単位です。
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1.mt-2 会社コード：
                        b-col.px-0
                          b-form-input.mb-2.mt-2(size="sm", type="text", v-model="order_info.neo.option.clouza.clouza_company", :disabled="selected_radio_list.clouza === '2'", :state="error_msg_list.clouza_company.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.clouza_company") {{ error_msg }}
                          b-form-text.description-text-position ※CLOUZAお試し環境からの引き継ぎがある場合のみ入力してください。
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-checkbox.mt-3(v-model="order_info.neo.option.clouza.paid_leave_option", :disabled="selected_radio_list.clouza === '2'", :state="error_msg_list.clouza_paid_leave.length === 0 ? null : false")
                            b-form-text 有休管理＋申請承認オプション
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.clouza_paid_leave") {{ error_msg }}
                          b-form-text.description-text-position ※タイムカード＋CLOUZA本体の契約ユーザー数と同数でのご契約となります。
                          p.mb-0.mt-2
                            a(
                              href="https://www.desknets.com/neo/pdf/article_timecardp.pdf",
                              target="_blank"
                            ) ＞ タイムカード＋CLOUZA利用約款
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.clouza') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。

                //- ディスク増設
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_neo_disk_size')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.disk.' + neo_disk_size_kind) === true ? 'contracted-icon' : 'un-contracted-icon'") ディスク増設
                  template(v-if="show_neo_disk_size === false")
                    b-row
                      b-col.space-col-size
                      b-col.form-inline
                        b-form-text.mt-0.mb-2(v-if="hasContract('neo.option.disk.' + neo_disk_size_kind) === true") 20GB × {{ contract_info.neo.option.disk[neo_disk_size_kind] }} = {{ getSumDiskSize(contract_info.neo.option.disk[neo_disk_size_kind]) }}GB
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.disk_size_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.ml-1.mb-3(v-model="selected_radio_list.disk_size", :state="error_msg_list.disk_size_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.option.disk.' + neo_disk_size_kind) === false")
                              b-form-radio(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1
                            template(v-if="hasContract('neo.option.disk.' + neo_disk_size_kind) === true") 変更後の
                            template 増設容量：
                        b-col.px-0
                          .form-inline
                            b-form-text.mt-0.mb-2.mx-1 20GB ×
                            b-form-input.mb-2.disk-form-class(size="sm", type="text", v-model="order_info.neo.option.disk[neo_disk_size_kind]", placeholder='（半角数字）', :disabled="selected_radio_list.disk_size === '2'", :state="error_msg_list.disk_size.length === 0 ? null : false")
                            b-form-text.mt-0.mb-2.mx-1 =
                            b-form-text.mt-0.mb-2.mx-1 {{ getSumDiskSize(order_info.neo.option.disk[neo_disk_size_kind]) }}GB 増設
                          div(data-testid="input_neo_disk_size_errors")
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.disk_size") {{ error_msg }}
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.disk.' + neo_disk_size_kind) === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) GB数の変更は販売店にお問い合わせください。

                //- Sync for smartphone
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_sync')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.sync') === true ? 'contracted-icon' : 'un-contracted-icon'") Sync for smartphones
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/sync/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_sync === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.neo.option.sync.user") {{ contract_info.neo.option.sync.user }} ユーザー
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.sync_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col.px-0
                          b-form-radio-group.mb-3(v-model="selected_radio_list.sync", :state="error_msg_list.sync_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.option.sync') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio.ml-1.mr-4(value='2') 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1
                            template(v-if="hasContract('neo.option.sync')") 変更後の
                            template ユーザー数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.option.sync.user", placeholder='（半角数字）', :disabled="selected_radio_list.sync === '2'", :state="error_msg_list.sync_user.length === 0 ? null : false")
                            b-form-text.ml-1.mt-0.mb-2 ユーザー
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.sync_user") {{ error_msg }}
                          b-form-text.description-text-position ※最低契約ユーザー数は5ユーザーです。
                          b-form-text.description-text-position ※ご契約単位は1ユーザー単位です。
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.sync') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) ユーザー数の変更は販売店にお問い合わせください。

                //- desknet'sドライブ ディスク増設
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_dndrive_disk_size')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.option.dn_drive') === true ? 'contracted-icon' : 'un-contracted-icon'") desknet'sドライブ ディスク増設
                  template(v-if="show_dndrive_disk_size === false")
                    b-row
                      b-col.space-col-size
                      b-col.form-inline
                        b-form-text.mt-0.mb-2(v-if="contract_info.neo.option.dn_drive.disk_size") 20GB × {{ contract_info.neo.option.dn_drive.disk_size }} = {{ getSumDndriveDiskSize(contract_info.neo.option.dn_drive.disk_size) }}GB
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.dn_drive") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.ml-1.mb-3(v-model="selected_radio_list.dn_drive")
                            template(v-if="hasContract('neo.option.dn_drive') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1") 利用内容を変更する
                              b-form-radio(value="2") 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1
                            template(v-if="hasContract('neo.option.dn_drive') === true") 変更後の
                            template 増設容量：
                        b-col.px-0
                          .form-inline
                            b-form-text.mt-0.mb-2.mx-1 20GB ×
                            b-form-input.mb-2.disk-form-class(size="sm", type="text", v-model="order_info.neo.option.dn_drive.disk_size", placeholder='（半角数字）', :disabled="selected_radio_list.dn_drive === '2'", :state="error_msg_list.dn_drive_disk_size.length === 0 ? null : false")
                            b-form-text.mt-0.mb-2.mx-1 =
                            b-form-text.mt-0.mb-2.mx-1 {{ getSumDndriveDiskSize(order_info.neo.option.dn_drive.disk_size) }}GB 増設
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.dn_drive_disk_size") {{ error_msg }}
                  b-form-text(v-if="sales_channel === '1'", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.option.dn_drive') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) GB数の変更は販売店にお問い合わせください。
                b-form-text(:class="neo_option_data_class" style="height: 30px;")

                //- desknet's NEO セキュリティオプション
                h5#neo_security_option(:class="neo_title_class") セキュリティオプション
                //- BASIC認証
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_neo_basic')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.security.basic') === true ? 'contracted-icon' : 'un-contracted-icon'") BASIC認証
                  template(v-if="show_neo_basic === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.neo.security.basic.basic_id") ユーザーID ： {{ contract_info.neo.security.basic.basic_id }}
                        basic-password(v-if="contract_info.neo.security.basic.basic_password", :password="contract_info.neo.security.basic.basic_password")
                        b-form-text.text-left(v-if="contract_info.neo.security.basic.basic_except_ip") 認証を除外するIPアドレス：
                          b-form-text.text-left.ml-1(v-for="ip_addr of getDisplayIPAddress(contract_info.neo.security.basic.basic_except_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.basic_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.basic", :state="error_msg_list.basic_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.security.basic') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1 ユーザーID：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.security.basic.basic_id", placeholder='（半角英数字）', :disabled="selected_radio_list.basic === '2'", :state="error_msg_list.basic_id.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.basic_id") {{ error_msg }}
                          b-form-text.ml-1.mt-0.mb-2
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1.mt-2 パスワード：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="password", v-model="order_info.neo.security.basic.basic_password", placeholder='（半角英数字）', :disabled="selected_radio_list.basic === '2'", :state="error_msg_list.basic_password.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="error_msg of error_msg_list.basic_password") {{ error_msg }}
                          b-form-text.ml-1.mt-0.mb-2
                      b-row.mt-1
                        b-col.space-col-size
                        b-col
                          b-form-text 認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.neo.security.basic.basic_except_ip", rows="3", :disabled="selected_radio_list.basic === '2'", :state="error_msg_list.basic_except_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.basic_except_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position.ml-3 特定のIPアドレスからの接続は認証しない：192.0.2.201
                          b-form-text.description-text-position.ml-3 特定のネットワークからの接続は認証しない：192.0.2.0/24

                //- 接続元IPアドレス制限
                b-form-text.no-data-font(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_neo_connect_permit')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.security.connect_permit_ip') === true ? 'contracted-icon' : 'un-contracted-icon'") 接続元IPアドレス制限
                  template(v-if="show_neo_connect_permit === false")
                    b-row
                      b-col.space-col-size
                      b-col(v-if="contract_info.neo.security.connect_permit_ip")
                        b-form-text.text-left 接続を許可するIPアドレス：
                        b-form-text.text-left.ml-1(v-for="(ip_addr) of getDisplayIPAddress(contract_info.neo.security.connect_permit_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="error_msg of error_msg_list.connect_permit_ip_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.connect_permit_ip", :state="error_msg_list.connect_permit_ip_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.security.connect_permit_ip') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row.mt-2
                        b-col.space-col-size
                        b-col
                          b-form-text 接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.neo.security.connect_permit_ip", rows="3", :disabled="selected_radio_list.connect_permit_ip === '2'", :state="error_msg_list.connect_permit_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.connect_permit_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position.ml-3 特定のIPアドレスからの接続を許可する：192.0.2.201
                          b-form-text.description-text-position.ml-3 特定のネットワークからの接続を許可する：192.0.2.0/24

                //- クライアント認証
                b-form-text.no-data-font(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true || hasContract('neo.security.client') === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_client')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.security.client') === true ? 'contracted-icon' : 'un-contracted-icon'") クライアント認証
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/clientcert/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_client === false")
                    b-row
                      b-col.space-col-size
                      b-col(v-if="contract_info.neo.security.client.device")
                        b-form-text.text-left(v-if="contract_info.neo.security.client.device") デバイス数：{{ contract_info.neo.security.client.device }} デバイス
                        b-form-text.text-left(v-if="contract_info.neo.security.client.cert_except_ip") 認証を除外するIPアドレス：
                        div
                          b-form-text.text-left.ml-1(v-for="(ip_addr) of getDisplayIPAddress(contract_info.neo.security.client.cert_except_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.client_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.client", :state="error_msg_list.client_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.security.client') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(v-if="is_direct_sales === true", value='2') 利用を終了する
                      template(v-if="is_direct_sales === true")
                        b-row.mt-3
                          b-col.space-col-size
                          b-col.px-0.title-col-size
                            b-form-text.text-right.mr-1
                              template(v-if="hasContract('neo.security.client') === true") 変更後の
                              template デバイス数：
                          b-col.px-0
                            .form-inline
                              b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.security.client.device", placeholder='（半角数字）', :disabled="selected_radio_list.client === '2'", :state="error_msg_list.client_device.length === 0 ? null : false")
                              b-form-text.ml-1.mt-0.mb-2 デバイス
                            div
                              b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.client_device") {{ error_msg }}
                            b-form-text.description-text-position ※最低契約デバイス数は5デバイスです。
                            b-form-text.description-text-position ※ご契約単位は1デバイス単位です。
                      template(v-else)
                        b-row
                          b-col.space-col-size
                          b-col.mb-3
                            b-form-text.text-left デバイス数 ： {{ contract_info.neo.security.client.device }} デバイス
                            b-form-text(text-variant="danger") デバイス数の変更は販売店にお問い合わせください。
                      b-row.mt-1
                        b-col.space-col-size
                        b-col
                          b-form-text 認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.neo.security.client.cert_except_ip", rows="3", :disabled="selected_radio_list.client === '2'", :state="error_msg_list.client_except_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.client_except_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position.ml-3 特定のIPアドレスからの接続は認証しない：192.0.2.201
                          b-form-text.description-text-position.ml-3 特定のネットワークからの接続は認証しない：192.0.2.0/24
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.security.client') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) デバイス数の変更は販売店にお問い合わせください。

                //- セキュアブラウザ
                b-form-text(:class="neo_option_data_class" v-if="hasContract('neo.security.secure') === true")
                  b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_secure')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1.contracted-icon セキュアブラウザ
                  template(v-if="show_secure === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left {{ contractDetailsFlgVar.secure_browser_terminal[contract_info.neo.security.secure.secure_browser_terminal] }}
                        b-form-text.text-left(v-if="contract_info.neo.security.secure.secure_browser_terminal === '02'") デバイス数 ： {{ contract_info.neo.security.secure.secure_browser_device }} デバイス
                        b-form-text.text-left(v-if="contract_info.neo.security.secure.secure_except_ip") セキュアブラウザを適用しないIPアドレス ：
                        div
                          b-form-text.text-left.ml-1(v-for="(ip_addr) of getDisplayIPAddress(contract_info.neo.security.secure.secure_except_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.secure", :state="error_msg_list.secure_select.length === 0 ? null : false")
                            b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                            b-form-radio(v-if="is_direct_sales === true", value='2') 利用を終了する
                      b-row.mt-3.ml-3
                        template(v-if="is_direct_sales === true")
                          b-col.px-0.title-col-size
                            b-form-text.text-right.mr-1 端末認証：
                          b-col.px-0
                            b-form-radio-group(v-model="order_info.neo.security.secure.secure_browser_terminal", :stacked="true", :disabled="selected_radio_list.secure === '2'", :state="error_msg_list.secure_terminal.length === 0 ? null : false")
                              b-form-radio.m-1(value='01') 端末認証なし
                                b-form-text ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                              b-form-radio.m-1(value='02') 端末認証あり
                                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_terminal") {{ error_msg }}
                        template(v-else)
                          b-col.space-col-size
                          b-col.mb-3
                            b-form-text.text-left {{ contractDetailsFlgVar.secure_browser_terminal[contract_info.neo.security.secure.secure_browser_terminal] }}
                            b-form-text.text-left(v-if="contract_info.neo.security.secure.secure_browser_terminal === '02'") デバイス数 ： {{ contract_info.neo.security.secure.secure_browser_device }} デバイス
                            b-form-text(v-if="contract_info.neo.security.secure.secure_browser_terminal === '02'", text-variant="danger") デバイス数の変更は販売店にお問い合わせください。
                      template(v-if="is_direct_sales === true")
                        b-collapse(v-model="device_collapse")
                          b-row.mt-1
                            b-col.space-col-size
                            b-col.ml-5
                              b-form-radio-group(v-model="order_info.neo.security.secure.secure_browser_certificate_action", :stacked="true", :disabled="selected_radio_list.secure === '2'", :state="error_msg_list.secure_certificate_action.length === 0 ? null : false")
                                b-form-text.mb-2.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_certificate_action") {{ error_msg }}
                                b-form-radio.m-1.ml-4(value='01') 証明書を追加する
                                  .form-inline
                                    b-form-text 変更後のデバイス数：
                                    b-form-input(
                                      size="sm",
                                      type="text",
                                      :disabled="selected_radio_list.secure === '2' || order_info.neo.security.secure.secure_browser_certificate_action !== '01'",
                                      v-model="order_info.neo.security.secure.secure_browser_device",
                                      placeholder='（半角数字）',
                                      :state="error_msg_list.secure_device.length === 0 ? null : false"
                                    )
                                    b-form-text.ml-1 デバイス
                                    b-form-text.secure-device-description ※最低契約デバイス数は5デバイスです。
                                    b-form-text.secure-device-description ※ご契約単位は1デバイス単位です。
                                    div
                                      b-form-text.secure-device-description.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_device") {{ error_msg }}
                                b-form-radio.m-1.mt-3.ml-4(value='02') 証明書を再発行する
                                  b-row(style="width: 445px;")
                                    b-col
                                      b-form-text 再発行する証明書（1行に1件ずつ記入）：
                                      b-form-textarea(
                                        v-model="order_info.neo.security.secure.secure_browser_re_create",
                                        rows="3",
                                        :disabled="selected_radio_list.secure === '2' || order_info.neo.security.secure.secure_browser_certificate_action !== '02'",
                                        :state="error_msg_list.secure_re_certificate.length === 0 ? null : false"
                                      )
                                      b-form-text.description-text-position ※記入例：oncloud0001.p12
                                      div
                                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_re_certificate") {{ error_msg }}
                                b-form-radio.m-1.mt-3.ml-4(value='03') 証明書を削減する
                                  b-row(style="width: 445px;")
                                    b-col
                                      b-form-text 削減する証明書（1行に1件ずつ記入）：
                                      b-form-textarea(
                                        v-model="order_info.neo.security.secure.secure_browser_delete_certificate",
                                        rows="3",
                                        :disabled="selected_radio_list.secure === '2' || order_info.neo.security.secure.secure_browser_certificate_action !== '03'",
                                        :state="error_msg_list.secure_delete_certificate.length === 0 ? null : false"
                                      )
                                      b-form-text.description-text-position ※記入例：oncloud0001.p12
                                      b-form-text.description-text-position ※証明書を再発行または削減する場合、対象の証明書は失効されます。
                                      div
                                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_delete_certificate") {{ error_msg }}
                                b-form-radio.m-1.mt-3.ml-4(value='04') 証明書の変更なし
                      b-row.mt-1
                        b-col.space-col-size
                        b-col
                          b-form-text セキュアブラウザを適用しないIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.neo.security.secure.secure_except_ip", rows="3", :disabled="selected_radio_list.secure === '2'", :state="error_msg_list.secure_except_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.secure_except_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position.ml-3 特定のIPアドレスからの接続は認証しない：192.0.2.201
                          b-form-text.description-text-position.ml-3 特定のネットワークからの接続は認証しない：192.0.2.0/24
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3 デバイス数の変更は販売店にお問い合わせください。
                b-form-text(:class="neo_option_data_class" style="height: 30px;")

                //- desknet's NEO メールサービス
                h5#neo_mail_service(:class="neo_title_class") メールサービス

                //- WebARENA
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_arena')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.mail.arena') === true ? 'contracted-icon' : 'un-contracted-icon'") WebARENA
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/mail/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_arena === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.neo.mail.arena.wa_domain") 利用ドメイン名 ：{{ contract_info.neo.mail.arena.wa_domain }}
                        b-form-text.text-left(v-if="contract_info.neo.mail.arena.account") アカウント数 ： {{ contract_info.neo.mail.arena.account }} アカウント
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.arena_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.arena", :state="error_msg_list.arena_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.mail.arena') === false")
                              b-form-radio.ml-1.mr-4(value='0') 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value='1') 利用内容を変更する
                              b-form-radio(value='2') 利用を終了する
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right 利用ドメイン名：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.mail.arena.wa_domain", placeholder='（半角英数字）', :disabled="selected_radio_list.arena === '2'", :state="error_msg_list.arena_domain.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.arena_domain") {{ error_msg }}
                          b-form-text.description-text-position ※半角英数字および「-」と「.」のみで入力してください
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right
                            template(v-if="hasContract('neo.mail.arena') === true") 変更後の
                            template アカウント数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.mail.arena.account", placeholder='（半角数字）', :disabled="selected_radio_list.arena === '2'", :state="error_msg_list.arena_account.length === 0 ? null : false")
                            b-form-text.ml-1.mb-2 アカウント
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.arena_account") {{ error_msg }}
                          b-form-text.description-text-position ※最小25～最大1000アカウント迄ご利用可能です。
                          b-form-text.description-text-position ※ご契約単位は1アカウント単位です。
                      b-row
                        b-col.space-col-size
                        b-col.px-0.mt-1
                          a(
                            href="https://www.desknets.com/cloud/article_cloudmail.pdf",
                            target="_blank"
                          ) ＞ WebARENA利用約款
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.mail.arena') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。

                //- CYBERMAILΣ
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_cyber')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.mail.cyber') === true ? 'contracted-icon' : 'un-contracted-icon'") CYBERMAILΣ
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/", target="_blank") 詳細はこちら ＞
                  template(v-if="show_cyber === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.neo.mail.cyber.account") アカウント数 ： {{ contract_info.neo.mail.cyber.account }} アカウント
                        b-form-text.text-left.mb-2(v-if="contract_info.neo.mail.cyber.account") メールボックス容量 ： {{ cyber_mail_box_size }} GB
                        b-form-text.font-weight-bold.text-left.mb-1(v-if="contract_info.neo.mail.cyber.options.length > 0") オプション
                        template(v-for="option in contract_info.neo.mail.cyber.options")
                          b-form-text.text-left ・{{ getCyberMailOptionName(option) }}を利用する
                          template(v-if="option === '02' && contract_info.neo.mail.cyber.keep !== null")
                            b-form-text.text-left.ml-3 （ {{ cyber_mail_achieve_year }}年保存 ）
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.cyber", :state="error_msg_list.cyber_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.mail.cyber') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1", @change="resetDate") 利用内容を変更する
                              b-form-radio(value="2", @change="setInitDate") 利用を終了する
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right
                            template(v-if="hasContract('neo.mail.cyber') === true") 変更後の
                            template アカウント数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.mail.cyber.account", placeholder='（半角数字）', :disabled="selected_radio_list.cyber === '2'", :state="error_msg_list.cyber_account.length === 0 ? null : false")
                            b-form-text.ml-1.mb-2 アカウント
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.cyber_account") {{ error_msg }}
                          b-form-text.description-text-position ※最小50アカウントからご利用可能です。
                          b-form-text.description-text-position ※ご契約単位は10アカウント単位です。
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right メールボックス容量：
                        b-col.px-0
                          .form-inline
                            b-form-select(v-model="order_info.neo.mail.cyber.mailbox", :options="mailbox_option", value-field="value", text-field="name", size="sm", :disabled="selected_radio_list.cyber === '2'", :state="error_msg_list.cyber_mailbox.length === 0 ? null : false")
                            div
                              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_mailbox") {{ error_msg }}
                        .form-inline
                          div
                            b-form-text.align-left.text-left.ml-4.error-message-color(v-for="(error_msg) of error_msg_list.cyber_option") {{ error_msg }}
                        b-form-group.align-content.mt-3(label-cols="4", label-align="right", label-size="sm", label='オプション：', :disabled="selected_radio_list.cyber === '2'")
                          b-form-checkbox-group(v-model="order_info.neo.mail.cyber.options", :state="error_msg_list.cyber_option.length === 0 ? null : false")
                            b-form-checkbox(value='00') 情報漏えい対策(有償)
                              b-form-text ※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイル全文チェック)および個人情報漏洩 対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。
                            b-form-checkbox.mt-3(value='01') 添付ファイル暗号化・分離(有償)
                              b-form-text ※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。
                            b-form-checkbox.mt-3(value='02') メールアーカイブ＆監査(有償)
                              b-collapse(v-model="select_cyber_mail_achieve")
                                .form-inline
                                  b-form-select.mt-1.ml-3(v-model="order_info.neo.mail.cyber.keep", :options="cyber_mail_achieve_option", value-field="value", text-field="name", size="sm", :disabled="selected_radio_list.cyber === '2'", :state="error_msg_list.cyber_keep.length === 0 ? null : false")
                                  div
                                    b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.cyber_keep") {{ error_msg }}
                            b-form-checkbox.mt-3(value='03') クラウド型サンドボックス(有償)
                              p 上記以外のオプション(メール無害化など)をご希望のお客様は、弊社まで
                                a(href="https://www.desknets.com/neo/inquiry/", target="_blank") お問合せ
                                | ください。
                      b-row
                        b-col.space-col-size
                        b-col.px-0.mt-1
                          a(
                            href="https://www.cybersolutions.co.jp/admission/admission-CYBERMAILSIGMA.pdf",
                            target="_blank"
                          ) ＞ CYBERMAILΣ利用約款
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.mail.cyber') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。
                b-form-text(:class="neo_option_data_class", style="height: 30px;")

                //- desknet's NEO メールセキュリティサービス
                h5#neo_mail_security_service(:class="neo_title_class") メールセキュリティサービス

                //- MAILGATES Σ
                b-form-text(:class="neo_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_mailgates')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('neo.mail_security.mailgates') === true ? 'contracted-icon' : 'un-contracted-icon'") MAILGATES Σ
                  b-button.detail-button(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/#mailgates", target="_blank") 詳細はこちら ＞
                  template(v-if="show_mailgates === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.neo.mail_security.mailgates.mailgates_domain") 利用ドメイン名 ：{{ contract_info.neo.mail_security.mailgates.mailgates_domain }}
                        b-form-text.text-left(v-if="contract_info.neo.mail_security.mailgates.account") アカウント数 ： {{ contract_info.neo.mail_security.mailgates.account }} アカウント
                        b-form-text.font-weight-bold.text-left.mb-1(v-if="contract_info.neo.mail_security.mailgates.options.length > 0") オプション
                        template(v-for="option in contract_info.neo.mail_security.mailgates.options")
                          b-form-text.text-left ・{{ getMailgatesOptionName(option) }}を利用する
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.mailgates_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.mailgates", :state="error_msg_list.mailgates_select.length === 0 ? null : false")
                            template(v-if="hasContract('neo.mail_security.mailgates') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1") 利用内容を変更する
                              b-form-radio(value="2") 利用を終了する
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right 利用ドメイン名：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.mail_security.mailgates.mailgates_domain", placeholder='（半角英数字）', :disabled="selected_radio_list.mailgates === '2'", :state="error_msg_list.mailgates_domain.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.mailgates_domain") {{ error_msg }}
                          b-form-text.description-text-position ※半角英数字および「-」と「.」のみで入力してください
                      b-row.mt-3
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right
                            template(v-if="hasContract('neo.mail_security.mailgates') === true") 変更後の
                            template アカウント数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.neo.mail_security.mailgates.account", placeholder='（半角数字）', :disabled="selected_radio_list.mailgates === '2'", :state="error_msg_list.mailgates_account.length === 0 ? null : false")
                            b-form-text.ml-1.mb-2 アカウント
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.mailgates_account") {{ error_msg }}
                          b-form-text.description-text-position ※最小50アカウントからご利用可能です。
                          b-form-text.description-text-position ※ご契約単位は10アカウント単位です。
                      b-row.mt-3
                        b-col.space-col-size
                        .form-inline
                          div
                            b-form-text.align-left.text-left.ml-4.error-message-color(v-for="(error_msg) of error_msg_list.mailgates_option") {{ error_msg }}
                        b-form-group.align-content.mt-3(label-cols="4", label-align="right", label-size="sm", label='オプション：', :disabled="selected_radio_list.mailgates === '2'")
                          b-form-checkbox-group(v-model="order_info.neo.mail_security.mailgates.options", :state="error_msg_list.mailgates_option.length === 0 ? null : false")
                            b-form-checkbox(value='01') アンチウイルス・スパム＋サンドボックス
                              b-form-text ※ウイルス・迷惑メール対策(アンチウイルス・スパム)、フィッシング対策(URLフィルタリング)、なりすまし対策(SPF DKIM DMARC設定)、BEC対策(アドレス詐称判定)、サンドボックスを利用できます。
                            b-form-checkbox.mt-3(value='02') 誤送信対策・審査
                              b-form-text(text-variant="danger") 添付ファイル暗号化・分離と同時に申込みできません。
                              b-form-text ※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイルの全文チェック)および個人情報漏洩対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。
                            b-form-checkbox.mt-3(value='03') 添付ファイル暗号化・分離
                              b-form-text(text-variant="danger") 誤送信対策・審査と同時に申込みできません。
                              b-form-text ※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。
                      b-row
                        b-col.space-col-size
                        b-col.px-0.mt-1
                          a(
                            href="https://www.cybersolutions.co.jp/admission/admission-MAILGATESSIGMA.pdf",
                            target="_blank"
                          ) ＞ MAILGATES Σ利用約款
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3
                    span(v-if="hasContract('neo.mail_security.mailgates') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) サービス内容の変更は販売店にお問い合わせください。
                b-form-text(:class="neo_option_data_class", style="height: 30px;")

              //- ChatLuck単体の契約がある場合、ChatLuckユーザー数を表示
              template(v-if="hasContract('chat.chat_user') === true")
                h5#chat(:class="chat_title_class")
                  label.contracted-icon ビジネスチャット ChatLuck
                  b-button.plan-btn.ml-2(v-if="is_direct_sales === true", pill, variant="outline-primary", size="sm", @click="changePlan")
                    span プラン変更
                b-form-text(:class="chat_data_class")
                  b-button.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_chat')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  template(v-if="show_chat === false")
                    label.mb-0 {{ order_info.chat.chat_user }} ユーザー
                  template(v-else)
                    .input-div-size
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-2 変更後のユーザー数：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2(size="sm", type="text", v-model="order_info.chat.chat_user", placeholder='（半角数字）', :state="error_msg_list.chat_user.length === 0 ? null : false")
                            b-form-text.ml-1.mt-0.mb-2 ユーザー
                            div
                              b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.chat_user") {{ error_msg }}
                            b-form-text.description-text-position ※最低契約ユーザー数は5ユーザーです。
                            b-form-text.description-text-position ※ご契約単位は1ユーザー単位です。
                  b-form-text(v-if="is_direct_sales === false", text-variant="danger").ml-3 ユーザー数の変更は販売店にお問い合わせください。
                b-form-text(style="height: 30px;")

              //- ChatLuck を含むプランの場合、または、ChatLuck単体の契約がある場合
              template(v-if="isContainChatLuckInPlan(plan_info.name) === true || hasContract('chat.chat_user') === true")
                h4#chat_option_service.font-weight-bold ChatLuck ご利用オプションサービス
                h5(:class="chat_title_class") オプションサービス

                //- ディスク増設
                b-form-text(:class="chat_option_data_class")
                  b-button.mb-1.mr-2(v-if="is_direct_sales === true", variant="outline-info", size="sm", @click="toggleShowFlg('show_chat_disk_size')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('chat.option.disk.disk_size') === true ? 'contracted-icon' : 'un-contracted-icon'") ディスク増設
                  template(v-if="show_chat_disk_size === false")
                    b-row
                      b-col.space-col-size
                      b-col.form-inline
                        b-form-text.mt-0.mb-2(v-if="hasContract('chat.option.disk.disk_size')") 20GB × {{ contract_info.chat.option.disk.disk_size }} = {{ getSumDiskSize(contract_info.chat.option.disk.disk_size) }}GB増設
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.chat_disk_size_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.ml-1.mb-3(v-model="selected_radio_list.chat_disk_size", :state="error_msg_list.chat_disk_size_select.length === 0 ? null : false")
                            template(v-if="hasContract('chat.option.disk.disk_size') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1") 利用内容を変更する
                              b-form-radio(value="2") 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1
                            template(v-if="hasContract('chat.option.disk.disk_size') === true") 変更後の
                            template 増設容量：
                        b-col.px-0
                          .form-inline
                            b-form-text.mt-0.mb-2.mx-1 20GB ×
                            b-form-input.mb-2.disk-form-class(size="sm", type="text", v-model="order_info.chat.option.disk.disk_size", placeholder='（半角数字）', :disabled="selected_radio_list.chat_disk_size === '2'", :state="error_msg_list.chat_disk_size.length === 0 ? null : false")
                            b-form-text.mt-0.mb-2.mx-1 =
                            b-form-text.mt-0.mb-2.mx-1 {{ getSumDiskSize(order_info.chat.option.disk.disk_size) }}GB 増設
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.chat_disk_size") {{ error_msg }}
                  b-form-text(v-if="sales_channel === '1'", text-variant="danger").ml-3
                    span(v-if="hasContract('chat.option.disk.disk_size') === false") 新規契約申し込みは販売店にお問い合わせください。
                    span(v-else) GB数の変更は販売店にお問い合わせください。
                b-form-text(:class="chat_option_data_class" style="height: 30px;")

                //- ChatLuck セキュリティオプション
                h5#chat_security_option(:class="chat_title_class") セキュリティオプション

                //- BASIC認証
                b-form-text(:class="chat_option_data_class")
                  b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_chat_basic')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('chat.security.basic') === true ? 'contracted-icon' : 'un-contracted-icon'") BASIC認証
                  template(v-if="show_chat_basic === false")
                    b-row
                      b-col.space-col-size
                      b-col
                        b-form-text.text-left(v-if="contract_info.chat.security.basic.basic_id") ユーザーID ： {{ contract_info.chat.security.basic.basic_id }}
                        basic-password(v-if="contract_info.chat.security.basic.basic_password", :password="contract_info.chat.security.basic.basic_password")
                        b-form-text.text-left(v-if="contract_info.chat.security.basic.basic_except_ip") 認証を除外するIPアドレス：
                        div
                          b-form-text.text-left.ml-1(v-for="(ip_addr) of getDisplayIPAddress(contract_info.chat.security.basic.basic_except_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.chat_basic_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.chat_basic", :state="error_msg_list.chat_basic_select.length === 0 ? null : false")
                            template(v-if="hasContract('chat.security.basic') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1") 利用内容を変更する
                              b-form-radio(value="2") 利用を終了する
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1 ユーザーID：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2.data-col-width(size="sm", type="text", v-model="order_info.chat.security.basic.basic_id", placeholder='（半角英数字）', :disabled="selected_radio_list.chat_basic === '2'", :state="error_msg_list.chat_basic_id.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.chat_basic_id") {{ error_msg }}
                          b-form-text.ml-1.mt-0.mb-2
                      b-row
                        b-col.space-col-size
                        b-col.px-0.title-col-size
                          b-form-text.text-right.mr-1.mt-2 パスワード：
                        b-col.px-0
                          .form-inline
                            b-form-input.mb-2.data-col-width(size="sm", type="password", v-model="order_info.chat.security.basic.basic_password", placeholder='（半角英数字）', :disabled="selected_radio_list.chat_basic === '2'", :state="error_msg_list.chat_basic_password.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.chat_basic_password") {{ error_msg }}
                          b-form-text.ml-1.mt-0.mb-2
                      b-row.mt-1
                        b-col.space-col-size
                        b-col
                          b-form-text 認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.chat.security.basic.basic_except_ip", rows="3", :disabled="selected_radio_list.chat_basic === '2'", :state="error_msg_list.chat_basic_except_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.chat_basic_except_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position.mk-3 特定のIPアドレスからの接続は認証しない：192.0.2.201
                          b-form-text.description-text-position.mk-3 特定のネットワークからの接続は認証しない：192.0.2.0/24

                //- ChatLuck 接続元IPアドレス制限
                b-form-text(:class="chat_option_data_class")
                  b-button.mb-1.mr-2(variant="outline-info", size="sm", @click="toggleShowFlg('show_chat_connect_permit')")
                    span 変更
                    b-icon(scale=0.7, icon="chevron-double-down")
                  label.ml-1(:class="hasContract('chat.security.connect_permit_ip') === true ? 'contracted-icon' : 'un-contracted-icon'") 接続元IPアドレス制限
                  template(v-if="show_chat_connect_permit === false")
                    b-row
                      b-col.space-col-size
                      b-col(v-if="contract_info.chat.security.connect_permit_ip")
                        b-form-text.text-left 接続を許可するIPアドレス：
                        div
                          b-form-text.text-left.ml-1(v-for="(ip_addr) of getDisplayIPAddress(contract_info.chat.security.connect_permit_ip)") {{ ip_addr }}
                  template(v-else)
                    .input-div-size
                      div
                        b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.chat_connect_permit_ip_select") {{ error_msg }}
                      b-row
                        b-col.space-col-size
                        b-col
                          b-form-radio-group.mb-3(v-model="selected_radio_list.chat_connect_permit_ip", :state="error_msg_list.chat_connect_permit_ip_select.length === 0 ? null : false")
                            template(v-if="hasContract('chat.security.connect_permit_ip') === false")
                              b-form-radio.ml-1.mr-4(value="0") 新たに利用を開始する
                            template(v-else)
                              b-form-radio.ml-1.mr-4(value="1") 利用内容を変更する
                              b-form-radio(value="2") 利用を終了する
                      b-row.mt-2
                        b-col.space-col-size
                        b-col
                          b-form-text.mr-1.mb-2.mt-0 接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）：
                          b-form-textarea(v-model="order_info.chat.security.connect_permit_ip", rows="3", :disabled="selected_radio_list.chat_connect_permit_ip === '2'", :state="error_msg_list.chat_connect_permit_ip.length === 0 ? null : false")
                          div
                            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.chat_connect_permit_ip") {{ error_msg }}
                          b-form-text.description-text-position ※記入例：
                          b-form-text.description-text-position 特定のIPアドレスからの接続を許可する：192.0.2.201
                          b-form-text.description-text-position 特定のネットワークからの接続を許可する：192.0.2.0/24
                b-form-text(:class="chat_option_data_class", style="height: 30px;")

          //- 変更希望日
          h5#preferred_date.font-weight-bold.ml-3(:class="other_title_class") 変更希望日
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", label='希望日', :label-class="required_label_class")
            b-form-select.mb-2.date-size(
              v-if="show_cyber === true && selected_radio_list.cyber === '2'"
              v-model="common_info.opening_date",
              :options="setOffsetDateOptions(common_info.offset_date_list)",
              value-field="value",
              text-field="name",
              size="sm"
            )
            b-form-datepicker.mb-2.date-size(
              v-else,
              size="sm",
              v-model="common_info.opening_date",
              :min="preferred_date_min",
              :max="preferred_date_max"
              placeholder='（カレンダーから選択）',
              :hide-header="true",
              :date-format-options="{year: 'numeric', month: 'long', day: 'numeric'}",
              :date-disabled-fn="dateDisabled",
              :state="error_msg_list.preferred_date.length !== 0 ? false : null"
            )
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.preferred_date") {{ error_msg }}
            b-form-text.mt-0 ※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。
            b-form-text.mt-0 ※希望日が弊社休業日の場合、翌営業日のご希望として承ります。
            b-form-text.mt-0 ※希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。
            b-form-text.mt-0(v-if="show_cyber === true && selected_radio_list.cyber === '2'", text-variant="danger") ※CYBERMAILΣの解約申込みを行う場合は、翌月または翌々月の最終営業日からの選択となります。
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")

          //- お見積番号
          h5#estimate.font-weight-bold.ml-3(:class="other_title_class") お見積番号
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", label='お見積番号', :label-class="elective_label_class")
            .form-inline
              b-form-text.mr-1 No.
              b-form-textarea.mb-2.estimate-size(v-model="common_info.estimate_no", rows="3")
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of error_msg_list.estimate_no") {{error_msg}}
            b-form-text.mt-0(text-variant="danger") 既に弊社から見積を取得されている場合、必ずご記入ください。
            b-form-text.mt-0 ※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")

          //- 備考
          h5#remarks.font-weight-bold.ml-3(:class="other_title_class") 備考
          b-container.sub-b-container
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", label='弊社への連絡事項などございましたら、こちらにご記入ください。', :label-class="elective_label_class")
              b-form-textarea(v-model="common_info.order_remarks", rows="4")

          //- サービス利用約款など
          h5#service_terms.font-weight-bold.ml-3(:class="other_title_class") サービス利用約款など
          b-container.sub-b-container
            //- desknet's NEOが含まれるプランである場合
            p(v-if="plan_info.name !== ''")
              a(href="https://www.desknets.com/cloud/article.pdf", target="_blank") ＞ desknet'sクラウドサービス利用約款
            //- ChatLuck を含むプランの場合、または、ChatLuck単体の契約がある場合
            p(v-if="isContainChatLuckInPlan(plan_info.name) === true || hasContract('chat.chat_user') === true")
              a(href="https://www.chatluck.com/terms/tos-cloud.pdf", target="_blank") ＞ ChatLuckクラウドサービス利用約款
            p
              b-link(href="/tos.pdf", target="_blank") ＞ クラウド版サポートサイト利用規約
            b-form-textarea.white-space(v-model="provision.value", :disabled="true", rows="6")
            b-form-group.mt-3.mb-0.align-content.text-danger(label-cols="12", label-align="left", label-size="sm", :label="provision.label")
            b-form-checkbox.mx-auto(v-model="provision_check.checked" :state="error_msg_list.provision_check.length === 0 ? null : false" @change="toggleNextButtonDisabled") {{provision_check.label}}
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of error_msg_list.provision_check") {{error_msg}}
          b-button.float-right.mr-5.my-3(pill, variant="outline-primary", size="lg", @click="checkOrder()", :disabled="nextButtonDisabled")
            .float-left.search_message.mr-1.font-weight-bold 次へ
            b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
import AppMessages from '@/components/AppMessages.vue';
import Loading from '@/components/Loading'
import { cl_contract_details_tbl as lang_cl_contract_details_tbl } from '@/lang/ja_JP'
import BasicPassword from '@/components/BasicPassword';
import Api from "@/repositories/api";

const C206ContractInfo = Api.get('c206ContractInfo');
const S213ContractDetailsRepository = Api.get("s213ContractDetails");
const S213ContractChangesRepository = Api.get("s213ContractChanges");

export default {
  name: 'ContractChanges',
  components: {
    AppMessages,
    Loading,
    BasicPassword,
  },
  props: {
    // 販売経由
    sales_channel: { type: String, required: true },
    // 契約情報
    contract_info: { type: Object, required: true },
    // 注文情報
    order_info: { type: Object, required: true },
    // その他情報
    common_info: { type: Object, required: true },
  },
  data() {
    return {
      // 必須のクラス
      required_label_class: 'py-05 mb-4 required-label-after',
      // 任意のクラス
      elective_label_class: 'py-05 mb-4 elective-label-after',

      // タイトルのクラス
      plan_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 plan-title-bg-color',
      plan_data_class: 'ml-3 py-2 px-2 my-2 border-top border-bottom border-plan label-font-size',
      neo_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 neo-title-bg-color',
      neo_data_class: 'ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size',
      neo_option_data_class: 'ml-3 pt-2 px-2 mb-0 border-top border-primary label-font-size',
      chat_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 chat-title-bg-color',
      chat_data_class: 'ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size',
      chat_option_data_class: 'ml-3 pt-2 px-2 mb-0 border-top border-success label-font-size',
      other_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 other-title-bg-color',

      // 変更フォームの開閉フラグ
      show_plan: false,
      show_app_suite: false,
      show_web_conferencing: false,
      show_room_mgr: false,
      show_expense_settlement: false,
      show_clouza: false,
      show_neo_disk_size: false,
      show_sync: false,
      show_dndrive_disk_size: false,
      show_neo_basic: false,
      show_neo_connect_permit: false,
      show_client: false,
      show_secure: false,
      show_arena: false,
      show_cyber: false,
      show_mailgates: false,
      show_chat: false,
      show_chat_disk_size: false,
      show_chat_basic: false,
      show_chat_connect_permit: false,

      // エラーメッセージ
      error_msg_list: {
        top: [],
        plan: [],
        app_suite: [],
        web_conferencing: [],
        room_mgr: [],
        expense_settlement: [],
        clouza_select: [],
        clouza_user: [],
        clouza_company: [],
        clouza_paid_leave: [],
        disk_size_select: [],
        disk_size: [],
        sync_select: [],
        sync_user: [],
        dn_drive: [],
        dn_drive_disk_size: [],
        basic_select: [],
        basic_id: [],
        basic_password: [],
        basic_except_ip: [],
        connect_permit_ip_select: [],
        connect_permit_ip: [],
        client_select: [],
        client_device: [],
        client_except_ip: [],
        secure_select: [],
        secure_terminal: [],
        secure_certificate_action: [],
        secure_device: [],
        secure_re_certificate: [],
        secure_delete_certificate: [],
        secure_except_ip: [],
        arena_select: [],
        arena_domain: [],
        arena_account: [],
        cyber_select: [],
        cyber_account: [],
        cyber_mailbox: [],
        cyber_option: [],
        cyber_keep: [],
        mailgates_select: [],
        mailgates_domain: [],
        mailgates_account: [],
        mailgates_option: [],
        chat_user: [],
        chat_disk_size_select: [],
        chat_disk_size: [],
        chat_basic_select: [],
        chat_basic_id: [],
        chat_basic_password: [],
        chat_basic_except_ip: [],
        chat_connect_permit_ip_select: [],
        chat_connect_permit_ip: [],
        preferred_date: [],
        estimate_no: [],
        remarks: [],
        provision_check:[],
      },

      // 選択したラジオボタン
      selected_radio_list: {
        plan: '1',
        app_suite: '0',
        web_conferencing: '0',
        room_mgr: '0',
        expense_settlement: '0',
        clouza: '0',
        disk_size: '0',
        sync: '0',
        dn_drive: '0',
        basic: '0',
        connect_permit_ip: '0',
        client: '0',
        secure: '1',
        arena: '0',
        cyber: '0',
        mailgates: '0',
        chat_user: '1',
        chat_disk_size: '0',
        chat_basic: '0',
        chat_connect_permit_ip: '0',
      },

      // CYBERMAILΣのメール容量の選択肢
      mailbox_option: [
        { value: '00', name: '（容量を選択してください）' },
        { value: '01', name: '5GB' },
        { value: '02', name: '10GB' },
        { value: '03', name: '50GB' },
        { value: '04', name: '100GB' }
      ],

      // CYBERMAILΣのメールアーカイブ保存期間の選択肢
      cyber_mail_achieve_option: [
        { value: '00', name: '（保存期間を選択してください）' },
        { value: '01', name: '5年保存' },
        { value: '02', name: '7年保存' },
      ],

      // 変更希望日の最小値
      preferred_date_min: '',
      // 変更希望日の最大値
      preferred_date_max: '',

      // エラー時のスクロール先
      error_scroll_position: 99,
      // 「次へ」ボタンの無効フラグ
      nextButtonDisabled: true,
      // 定義値
      contractDetailsFlgVar: lang_cl_contract_details_tbl,

      // リクエストデータ
      requestData: {},

      // エラーメッセージのアンカー位置
      arAnchorList: [
        'other',                     // 最上部
        'plan',                      // プラン
        'option_service',            // desknet's NEO ご利用オプションサービス
        'neo_option_service',        // オプションサービス(NEO)
        'neo_security_option',       // セキュリティオプション(NEO)
        'neo_mail_service',          // メールサービス(NEO)
        'neo_mail_security_service', // メールセキュリティサービス(NEO)
        'chat',                      // ChatLuck
        'chat_option_service',       // オプションサービス(Chat)
        'chat_security_option',      // セキュリティオプション(Chat)
        'preferred_date',            // 変更希望日
        'estimate',                  // お見積番号
        'remarks',                   // 備考
        'service_terms',             // サービス利用約款など
      ],
      // 個人情報の取得目的
      provision: {
        label: "お申込みいただくにあたり、各種サービス約款および上記の各条項にご同意ください。",
        value: "個人情報の取得目的\n" +
          "１．当社は、当Webサイトにおいて、下記に記載する目的でお客さまより個人情報をご提供いただきます。\n" +
          "　①　お客さまからの資料請求、お問合せ、製品購入申込み等々に対する当社からの返信・送付\n" +
          "　②　当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付および製品に関するその他の情報提供\n" +
          "　③　サービスと製品開発のための統計用データとしての利用\n" +
          "　④　カスタマーハラスメント等への対応・事実確認\n" +
          "\n" +
          "\n" +
          "反社会的勢力の排除について\n" +
          "１．お客さまは、現在または将来にわたって、下記のいずれにも該当しないことを表明、確約するものとします。\n" +
          "　①　暴力団\n" +
          "　②　暴力団員\n" +
          "　③　暴力団員でなくなった時から５年を経過しない者\n" +
          "　④　暴力団準構成員\n" +
          "　⑤　暴力団関係企業\n" +
          "　⑥　総会屋等、社会運動標ぼうゴロまたは特殊知能暴力集団\n" +
          "　⑦　その他上記各号に準ずるもの\n" +
          "２．お客さまは、自らまたは第三者を利用し、下記のいずれかに該当する行為を行わないことを表明、確約するものとします。\n" +
          "　①　暴力的な要求行為\n" +
          "　②　法的な責任を超えた不当な要求行為\n" +
          "　③　取引に関して、脅迫的な言動をし、または暴力を用いる行為\n" +
          "　④　風説を流布し、偽計または威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為\n" +
          "　⑤　その他上記各号に準ずる行為\n" +
          "３．お客さまが上記各項のいずれかに反したと認められることが判明した場合、および上記各項の表明、確約が虚偽の申告であることが判明した場合、当社は、催告その他の手続を要しないで、契約の解除その他の当社が必要と判断する対応をとることができます。\n" +
          "４．お客さまは、前項による契約の解除等について、一切異議を申し立てず、また賠償ないし補償を求めないとともに、これより当社に損害が生じた場合は、これを賠償するものします。\n" +
          "\n" +
          "\n" +
          "管轄裁判所\n" +
          "１．本条項に基づく契約は日本法に準拠し、お客さまと当社の間で訴訟の必要が生じた場合には、訴額に応じて、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。"
      },
      provision_check: {
        checked: false,
        label: "上記の条項に同意します。",
      },
    }
  },
  computed: {
    /**
     * 直販か販社か
     * @return {boolean} true: 直販、false: 販社
     */
    is_direct_sales() {
      return this.sales_channel !== '1'
    },
    /**
     * プラン情報を取得する
     */
    plan_info() {
      // プラン情報
      let arPlans = ['light_user', 'standard_user', 'premium_user', 'chatplus_user']
      // 各プラン情報が注文情報に含まれるか確認する
      for(let iIndex = 0; iIndex < arPlans.length; iIndex++) {
        // データが入っている場合
        if (this.contract_info[arPlans[iIndex]] !== '') {
          // レスポンスとして返す
          return {
            name: arPlans[iIndex],
            user: this.contract_info[arPlans[iIndex]]
          }
        }
      }

      // desknet's NEOが含まれるか確認する
      if ('neo' in this.contract_info && 'neo_user' in this.contract_info.neo && this.contract_info.neo.neo_user !== '') {
        // レスポンスとして返す
        return {
          name: 'neo.neo_user',
          user: this.contract_info.neo.neo_user
        }
      }

      // 上記以外はデフォルトを返す
      return {
        name: '',
        user: 0
      }
    },
    /**
     * AppSuiteの新旧どちらを使用しているか
     */
    app_suite_kind() {
      // 旧AppSuiteの場合
      if (this.contract_info.neo.app_suite_user_old !== '') {
        return 'app_suite_user_old'
      }
      // 上記以外の場合
      return 'app_suite_user'
    },
    /**
     * ディスク増設の新旧どちらを使用しているか
     */
    neo_disk_size_kind() {
      // 旧ディスク増設の場合
      if (this.contract_info.neo.option.disk.disk_size_old !== '') {
        return 'disk_size_old'
      }
      // 上記以外の場合
      return 'disk_size'
    },
    /**
     * セキュアブラウザのオプション
     */
    device_collapse: {
      get: function() {
        return this.order_info.neo.security.secure.secure_browser_terminal === '02'
      },
      set: function() {}
    },
    /**
     * CYBERMAILΣのメールボックス容量
     */
    cyber_mail_box_size() {
      // メールボックス容量を定義値から表示値に変換する
      switch (this.contract_info.neo.mail.cyber.mailbox) {
        // 5GBの場合
        case '01':
          return '5'
        // 10GBの場合
        case '02':
          return '10'
        // 50GBの場合
        case '03':
          return '50'
        // 100GBの場合
        case '04':
          return '100'
      }

      // 上記以外は空文字を返す
      return ''
    },
    /**
     * メールアーカイブの保存期間
     */
    cyber_mail_achieve_year() {
      // 保存期間を定義値から表示値に変換する
      switch (this.contract_info.neo.mail.cyber.keep) {
        // 5年保存の場合
        case '01':
          return '5'
        // 7年保存の場合
        case '02':
          return '7'
        // 10年保存の場合
        case '03':
          return '10'
      }

      // 上記以外の場合は空文字を返す
      return ''
    },
    /**
     * CYBERMAILΣのメールアーカイブ監査を選択しているか
     */
    select_cyber_mail_achieve: {
      get: function() {
        // メールアーカイブを持っているか
        return this.order_info.neo.mail.cyber.options.includes('02') === true
      },
      set: function() {}
    }
  },
  created() {
    // 画面パラメータに契約変更フラグが存在する場合
    if (('change_orders' in this.$route.params) === true) {
      // 契約内容から注文種別の初期値を設定する
      this.setOrderType()
        .then(() => {
          // 変更対象製品から変更フラグを設定する
          this.setChangeFlg()
        })
    }
    // 上記以外の場合
    else {
      // 読み込み中
      this.isLoading = true;
      // セッションストレージから見積枝番を削除
      sessionStorage.removeItem('estimate_branch');
      // 画面パラメータに契約番号が存在する場合
      if ('contract_no' in this.$route.params) {
        // S21301_契約内容取得処理を実行
        this.getServiceData({contract_no: this.$route.params.contract_no, from_page: 'change'})
        // 契約番号を設定
        this.common_info.contract_no = this.$route.params.contract_no
      }
      // 画面パラメータに契約番号が存在しない場合
      else {
        // C20601_契約情報取得処理を実行
        C206ContractInfo.get()
          .then((response) => {
            // 取得した契約情報数が1件の場合
            if (response.data.data.length === 1) {
              // S21301_契約内容取得処理を実行
              this.getServiceData({contract_no: response.data.data[0].contract_no, from_page: 'change'})
              // 契約番号を設定
              this.common_info.contract_no = response.data.data[0].contract_no
            }
            else {
              // セッションストレージにデータを保存
              sessionStorage.setItem('previous', 'ContractChanges')

              // S11500_ご契約環境選択画面に遷移
              this.$router.push({ name: 'ContractSelect' })

              // ローディング終了
              this.isLoading = false
            }
          })
          .catch((error) => {
            // 共通エラー処理
            this.apiError(error, '画面表示処理', 'Service')
            // エラーメッセージを表示する
            this.setErrors(error)
            // ローディング終了
            this.isLoading = false
          })
      }
    }

    //--------------------
    // datepickerの最小日付
    //--------------------
    // 今日の日付の取得
    let currentDate = new Date();

    // 開始日(Dateオブジェクト)
    let startDate = new Date(currentDate);

    // 作業用最小日付
    let formedStartDate = '';

    // 祝日データを取得
    const holiday = this.getHolidays()

    // 本日から空ける必要のある営業日数(N日目が開始日)
    let preparationCount = this.getPreparationDayCount()

    // datepickerの最小値を作成
    // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む
    for (let i = 0; i <= preparationCount; i++) {
      // YYYY-MM-DD の形式にする
      formedStartDate = startDate.getFullYear()
          + '-' + ('00' + (startDate.getMonth() + 1)).slice(-2)
          + '-' + ('00' + startDate.getDate()).slice(-2)

      // 土曜日または日曜日または祝日の場合はスキップ
      if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
        i--
      }

      // 最終日ではない場合は翌日へ
      if (i < preparationCount) {
        startDate.setDate(startDate.getDate() + 1)
      }
    }

    // 最小日付設定
    this.preferred_date_min = formedStartDate

    //--------------------
    // datepickerの最大日付
    //--------------------
    // 翌月末の日付取得
    let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
    this.preferred_date_max = maxDate.getFullYear()
        + '-' + ('00' + (maxDate.getMonth() + 1)).slice(-2)
        + '-' + ('00' + maxDate.getDate()).slice(-2)

    // サービス利用規約がチェックされている場合
    if (this.provision_check.checked === true) {
      // 「次へ」ボタンを有効にする
      this.toggleNextButtonDisabled()
    }
  },
  methods: {
    /**
     * プラン変更ボタンを押した際の処理
     */
    changePlan() {
      // 「S10302_プラン選択」画面へ遷移する
      this.$router.push({
        name: 'ApplyPlan',
        params: {
          // 契約番号
          contract_no: this.common_info.contract_no
        }
      })
    },
    /**
     * 契約内容から注文種別の初期値を設定する
     */
    async setOrderType() {
      // AppSuiteを契約している場合
      if (this.hasContract('neo.' + this.app_suite_kind) === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.app_suite = '1'
      }
      // ウェブ会議を契約している場合
      if (this.hasContract('neo.web_conferencing') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.web_conferencing = '1'
      }
      // RoomMgrを契約している場合
      if (this.hasContract('neo.option.room_mgr') === true) {
        // 注文種別の初期値を解約にする
        this.selected_radio_list.room_mgr = '2'
      }
      // 交通費・経費精算を契約している場合
      if (this.hasContract('neo.option.expense_settlement') === true) {
        // 注文種別の初期値を解約にする
        this.selected_radio_list.expense_settlement = '2'
      }
      // タイムカード+CLOUZAを契約している場合
      if (this.hasContract('neo.option.clouza') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.clouza = '1'
      }
      // ディスク増設を契約している場合
      if (this.hasContract('neo.option.disk.' + this.neo_disk_size_kind) === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.disk_size = '1'
      }
      // Sync for smartphoneを契約している場合
      if (this.hasContract('neo.option.sync') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.sync = '1'
      }
      // desknet'sドライブ ディスク増設を契約している場合
      if (this.hasContract('neo.option.dn_drive') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.dn_drive = '1'
      }
      // BASIC認証を契約している場合
      if (this.hasContract('neo.security.basic') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.basic = '1'
      }
      // 接続元IPアドレス制限を契約している場合
      if (this.hasContract('neo.security.connect_permit_ip') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.connect_permit_ip = '1'
      }
      // クライアント認証を契約している場合
      if (this.hasContract('neo.security.client') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.client = '1'
      }
      // セキュアブラウザを契約している場合
      if (this.hasContract('neo.security.secure') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.secure = '1'
      }
      // WebARENAを契約している場合
      if (this.hasContract('neo.mail.arena') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.arena = '1'
      }
      // CYBERMAILΣを契約している場合
      if (this.hasContract('neo.mail.cyber') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.cyber = '1'
      }
      // MAILGATESΣを契約している場合
      if (this.hasContract('neo.mail_security.mailgates') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.mailgates = '1'
      }
      // ChatLuck ディスク増設を契約している場合
      if (this.hasContract('chat.option.disk.disk_size') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.chat_disk_size = '1'
      }
      // ChatLuck BASIC認証を契約している場合
      if (this.hasContract('chat.security.basic') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.chat_basic = '1'
      }
      // ChatLuck 接続元IPアドレス制限を契約している場合
      if (this.hasContract('chat.security.connect_permit_ip') === true) {
        // 注文種別の初期値を変更にする
        this.selected_radio_list.chat_connect_permit_ip = '1'
      }

      return Promise.resolve();
    },
    /**
     * 変更対象製品から変更フラグを設定する
     */
    setChangeFlg() {
      // 各変更対象製品に対して、変更フラグを設定する
      this.common_info.target_product.map(item => {
        // プランの場合
        if (['light_user', 'standard_user', 'premium_user', 'chatplus_user'].includes(item.name) === true) {
          // プランの変更フラグをONにする
          this.show_plan = true
          // 選択肢を設定する
          this.selected_radio_list.plan = item.order_type
        }
        // desknet's NEOの場合
        else if (item.name === 'neo.neo_user') {
          // プランの変更フラグをONにする
          this.show_plan = true
          // 選択肢を設定する
          this.selected_radio_list.plan = item.order_type
        }
        // AppSuiteの場合
        else if (item.name === 'neo.app_suite_user' || item.name === 'neo.app_suite_user_old') {
          // AppSuiteの変更フラグをONにする
          this.show_app_suite = true
          // 選択肢を設定する
          this.selected_radio_list.app_suite = item.order_type
        }
        // ウェブ会議の場合
        else if (item.name === 'neo.web_conferencing') {
          // ウェブ会議の変更フラグをONにする
          this.show_web_conferencing = true
          // 選択肢を設定する
          this.selected_radio_list.web_conferencing = item.order_type
        }
        // RoomMgrの場合
        else if (item.name === 'neo.option.room_mgr') {
          // RoomMgrの変更フラグをONにする
          this.show_room_mgr = true
          // 選択肢を設定する
          this.selected_radio_list.room_mgr = item.order_type
        }
        // 交通費・経費精算の場合
        else if (item.name === 'neo.option.expense_settlement') {
          // 交通費・経費精算の変更フラグをONにする
          this.show_expense_settlement = true
          // 選択肢を設定する
          this.selected_radio_list.expense_settlement = item.order_type
        }
        // CLOUZAの場合
        else if (item.name === 'neo.option.clouza') {
          // CLOUZAの変更フラグをONにする
          this.show_clouza = true
          // 選択肢を設定する
          this.selected_radio_list.clouza = item.order_type
        }
        // ディスク増設の場合
        else if (item.name === 'neo.option.disk.disk_size' || item.name === 'neo.option.disk.disk_size_old') {
          // ディスク増設の変更フラグをONにする
          this.show_neo_disk_size = true
          // 選択肢を設定する
          this.selected_radio_list.disk_size = item.order_type
        }
        // Sync for smartphoneの場合
        else if (item.name === 'neo.option.sync') {
          // Sync for smartphoneの変更フラグをONにする
          this.show_sync = true
          // 選択肢を設定する
          this.selected_radio_list.sync = item.order_type
        }
        // desknet'sドライブ ディスク増設の場合
        else if (item.name === 'neo.option.dn_drive') {
          // desknet'sドライブ ディスク増設の変更フラグをONにする
          this.show_dndrive_disk_size = true
          // 選択肢を設定する
          this.selected_radio_list.dn_drive = item.order_type
        }
        // BASIC認証の場合
        else if (item.name === 'neo.security.basic') {
          // BASIC認証の変更フラグをONにする
          this.show_neo_basic = true
          // 選択肢を設定する
          this.selected_radio_list.basic = item.order_type
        }
        // 接続元IPアドレス制限の場合
        else if (item.name === 'neo.security.connect_permit_ip') {
          // 接続元IPアドレス制限の変更フラグをONにする
          this.show_neo_connect_permit = true
          // 選択肢を設定する
          this.selected_radio_list.connect_permit_ip = item.order_type
        }
        // クライアント認証の場合
        else if (item.name === 'neo.security.client') {
          // クライアント認証の変更フラグをONにする
          this.show_client = true
          // 選択肢を設定する
          this.selected_radio_list.client = item.order_type
        }
        // セキュアブラウザの場合
        else if (item.name === 'neo.security.secure') {
          // セキュアブラウザの変更フラグをONにする
          this.show_secure = true
          // 選択肢を設定する
          this.selected_radio_list.secure = item.order_type
        }
        // WebARENAの場合
        else if (item.name === 'neo.mail.arena') {
          // WebARENAの変更フラグをONにする
          this.show_arena = true
          // 選択肢を設定する
          this.selected_radio_list.arena = item.order_type
        }
        // CYBERMAILΣの場合
        else if (item.name === 'neo.mail.cyber') {
          // CYBERMAILΣの変更フラグをONにする
          this.show_cyber = true
          // 選択肢を設定する
          this.selected_radio_list.cyber = item.order_type
        }
        // MAILGATESΣの場合
        else if (item.name === 'neo.mail_security.mailgates') {
          // MAILGATESΣの変更フラグをONにする
          this.show_mailgates = true
          // 選択肢を設定する
          this.selected_radio_list.mailgates = item.order_type
        }
        // ChatLuckの場合
        else if (item.name === 'chat.chat_user') {
          // ChatLuckの変更フラグをONにする
          this.show_chat = true
          // 選択肢を設定する
          this.selected_radio_list.chat_user = item.order_type
        }
        // ChatLuck ディスク増設の場合
        else if (item.name === 'chat.option.disk.disk_size') {
          // ChatLuck ディスク増設の変更フラグをONにする
          this.show_chat_disk_size = true
          // 選択肢を設定する
          this.selected_radio_list.chat_disk_size = item.order_type
        }
        // ChatLuck BASIC認証の場合
        else if (item.name === 'chat.security.basic') {
          // ChatLuck BASIC認証の変更フラグをONにする
          this.show_chat_basic = true
          // 選択肢を設定する
          this.selected_radio_list.chat_basic = item.order_type
        }
        // ChatLuck 接続元IPアドレス制限の場合
        else if (item.name === 'chat.security.connect_permit_ip') {
          // ChatLuck 接続元IPアドレス制限の変更フラグをONにする
          this.show_chat_connect_permit = true
          // 選択肢を設定する
          this.selected_radio_list.chat_connect_permit_ip = item.order_type
        }
      })
    },
    /**
     * 定義値からプラン名を取得する
     *
     * @param {string} sPlanName プラン名
     * @return {string} プラン名の表示名
     */
    getPlanName(sPlanName) {
      // ライトプランの場合
      if (sPlanName === 'light_user') {
        return 'ライトプラン'
      }
      // スタンダードプランの場合
      if (sPlanName === 'standard_user') {
        return 'スタンダードプラン'
      }
      // プレミアムプランの場合
      if (sPlanName === 'premium_user') {
        return 'プレミアムプラン'
      }
      // チャットプラスプランの場合
      if (sPlanName === 'chatplus_user') {
        return 'チャットプラスプラン'
      }
      // desknet's NEOの場合
      if (sPlanName === 'neo.neo_user') {
        return 'ライトプラン'
      }
      // 上記以外の場合は空文字を返す
      return ''
    },
    /**
     * プランの中にAppSuite製品を含むか
     *
     * @param {string} sPlanName プラン名
     * @return {boolean} true：含む、false：含まない
     */
    isContainAppSuiteInPlan(sPlanName) {
      // スタンダード、プレミアムプランの場合は含む
      return ['standard_user', 'premium_user'].includes(sPlanName)
    },
    /**
     * プランの中にChatLuck製品を含むか
     *
     * @param {string} sPlanName プラン名
     * @return {boolean} true：含む、false：含まない
     */
    isContainChatLuckInPlan(sPlanName) {
      // プレミアム、チャットプラスプランの場合は含む
      return ['premium_user', 'chatplus_user'].includes(sPlanName)
    },
    /**
     * フラグを反転させる
     *
     * @param {string} sFlagName 反転対象のフラグ名
     */
    toggleShowFlg(sFlagName) {
      // フラグを反転させる
      this[sFlagName] = !this[sFlagName];

      // CYBERMAILΣの場合
      if (sFlagName === 'show_cyber') {
        // 変更フォームが開いていて、ラジオボタンが「利用を終了する」の場合
        if (this[sFlagName] === true && this.selected_radio_list.cyber === '2') {
          // 変更希望日に初期値をセット
          this.setInitDate()
        }
        else {
          // 日付を初期化する
          this.resetDate()
        }
      }
    },
    /**
     * 契約を持っているかどうか
     *
     * @param {string} sProductName 製品名
     * @return {boolean} true: 持っている、false: 持っていない
     */
    hasContract(sProductName) {
      // 製品名によって契約のどこを見るか決める
      switch(sProductName) {
        // AppSuiteの場合
        case 'neo.app_suite_user':
          // AppSuiteのユーザー数を対象とする
          return this.contract_info.neo.app_suite_user !== ''
        // 旧AppSuiteの場合
        case 'neo.app_suite_user_old':
          // 旧AppSuiteのユーザー数を対象とする
          return this.contract_info.neo.app_suite_user_old !== ''
        // ウェブ会議の場合
        case 'neo.web_conferencing':
          // ウェブ会議の会議室数を対象とする
          return this.contract_info.neo.web_conferencing !== ''
        // desknet's DBの場合
        case 'neo.cloud_db_user':
          // desknet's DBのユーザー数を対象とする
          return this.contract_info.neo.cloud_db_user !== ''
        // RoomMgrの場合
        case 'neo.option.room_mgr':
          // RoomMgrのフラグを対象とする
          return this.contract_info.neo.option.room_mgr !== false
        // 交通費・経費精算の場合
        case 'neo.option.expense_settlement':
          // 交通費・経費精算のフラグを対象とする
          return this.contract_info.neo.option.expense_settlement !== false
        // CLOUZAの場合
        case 'neo.option.clouza':
          // CLOUZAのユーザー数を対象とする
          return this.contract_info.neo.option.clouza.user !== ''
        // ディスク増設の場合
        case 'neo.option.disk.disk_size':
          // ディスク増設の数量を対象とする
          return this.contract_info.neo.option.disk.disk_size !== ''
        // 旧ディスク増設の場合
        case 'neo.option.disk.disk_size_old':
          // 旧ディスク増設の数量を対象とする
          return this.contract_info.neo.option.disk.disk_size_old !== ''
        // Sync for Smartphoneの場合
        case 'neo.option.sync':
          // Sync for Smartphoneのユーザー数を対象とする
          return this.contract_info.neo.option.sync.user !== ''
        // desknet'sドライブ ディスク増設の場合
        case 'neo.option.dn_drive':
          // desknet'sドライブのディスク増設を対象とする
          return this.contract_info.neo.option.dn_drive.disk_size !== ''
        // BASIC認証の場合
        case 'neo.security.basic':
          // BASIC IDを対象とする
          return this.contract_info.neo.security.basic.basic_id !== ''
        // 接続許可IPアドレスの場合
        case 'neo.security.connect_permit_ip':
          // 接続許可IPアドレスを対象する
          return this.contract_info.neo.security.connect_permit_ip !== ''
        // クライアント認証の場合
        case 'neo.security.client':
            // クライアント認証のデバイス数を対象とする
            return this.contract_info.neo.security.client.device !== ''
        // セキュアブラウザの場合
        case 'neo.security.secure':
          // セキュアブラウザ端末認証フラグを対象とする
          return this.contract_info.neo.security.secure.secure_browser_terminal !== ''
        // WebARENAの場合
        case 'neo.mail.arena':
          // WebARENAのアカウント数を対象とする
          return this.contract_info.neo.mail.arena.account !== ''
        // CYBERMAILΣの場合
        case 'neo.mail.cyber':
          // CYBERMAILΣのアカウント数を対象とする
          return this.contract_info.neo.mail.cyber.account !== ''
        // MAILGATESΣの場合
        case 'neo.mail_security.mailgates':
          // MAILGATESΣのアカウント数を対象とする
          return this.contract_info.neo.mail_security.mailgates.account !== ''
        // ChatLuckの場合
        case 'chat.chat_user':
          // ChatLuckユーザー数を対象とする
          return this.contract_info.chat.chat_user !== ''
        // ChatLuckディスク増設の場合
        case 'chat.option.disk.disk_size':
          // ChatLuckディスク増設の数量を対象とする
          return this.contract_info.chat.option.disk.disk_size !== ''
        // ChatLuckBASIC認証の場合
        case 'chat.security.basic':
          // ChatLuckBASIC IDを対象とする
          return this.contract_info.chat.security.basic.basic_id !== ''
        // ChatLuck接続元IPアドレス制限の場合
        case 'chat.security.connect_permit_ip':
          // 接続許可IPアドレスを対象とする
          return this.contract_info.chat.security.connect_permit_ip !== ''
      }

      // 上記以外の場合は契約なし
      return false
    },
    /**
     * ディスク増設の合計値を取得する
     *
     * @param {string} sDiskSize ディスク数量
     * @return {int} ディスク増設の合計値
     */
    getSumDiskSize(sDiskSize) {
      // 数字以外の場合
      if (isNaN(sDiskSize) === true) {
        // 0を返す
        return 0
      }

      // 20をかけた値を返す
      return 20 * Number(sDiskSize)
    },
    /**
     * dnドライブのディスク増設の合計値を取得する
     *
     * @param {string} sDiskSize ディスク数量
     * @return {int} ディスク増設の合計値
     */
    getSumDndriveDiskSize(sDiskSize) {
      // 数字以外の場合
      if (isNaN(sDiskSize) === true) {
        // 0を返す
        return 0
      }

      // 20をかけた値を返す
      return 20 * Number(sDiskSize)
    },
    /**
     * 表示用のIPアドレスを取得する
     *
     * @param {string} sIPAddress IPアドレス
     * @return {array} 表示用IPアドレス
     */
    getDisplayIPAddress(sIPAddress) {
      // null または 空文字の場合
      if (sIPAddress === null || sIPAddress === '') {
        // 空配列を返す
        return []
      }
      // 上記以外の場合は5個ずつ区切る
      return this.showItemsAsRow(sIPAddress, 5, '\n')
    },
    /**
     * CYBERMAILΣのオプション名を取得する
     *
     * @param {string} sOption オプションの定義値
     * @param {string} 表示用オプション名
     */
    getCyberMailOptionName(sOption) {
      // 定義値を表示名に変換する
      switch (sOption) {
        // 情報漏えい対策の場合
        case '00':
          return '情報漏えい対策(有償)'
        // 添付ファイル暗号化・分離の場合
        case '01':
          return '添付ファイル暗号化・分離(有償)'
        // メールアーカイブ＆監査の場合
        case '02':
          return 'メールアーカイブ＆監査(有償)'
        // クラウド型サンドボックスの場合
        case '03':
          return 'クラウド型サンドボックス(有償)'
      }

      // 上記以外は空文字を返す
      return ''
    },
    /**
     * MAILGATESΣのオプション名を取得する
     *
     * @param {string} sOption オプションの定義値
     * @param {string} 表示用オプション名
     */
    getMailgatesOptionName(sOption) {
      // 定義値を表示名に変換する
      switch (sOption) {
        // アンチウイルス・スパムサンドボックスの場合
        case '01':
          return 'アンチウイルス・スパム＋サンドボックス'
        // 誤送信対策・審査の場合
        case '02':
          return '誤送信対策・審査'
        // 添付ファイル暗号化・分離の場合
        case '03':
          return '添付ファイル暗号化・分離'
      }

      // 上記以外は空文字を返す
      return ''
    },
    /**
     * datepickerの選択不可日付を設定する
     *
     * @param {string} ymd 対象日付の 'YYYY-MM-DD' 形式の文字列（未使用だが、DatePicker の仕様で渡される
     * @param {Date} date  対象日付の Date オブジェクト
     * @returns {boolean}  true：選択不可、false：選択可能
     */
    dateDisabled(ymd, date) {
      // 曜日を取得する（日曜日 - 土曜日：0 - 6）
      const iWeekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + '-' + ('00' + (date.getMonth() + 1)).slice(-2)
          + '-' + ('00' + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 日曜日と土曜日と祝日の場合、選択不可にする
      return iWeekday === 0 || iWeekday === 6 || holiday.includes(day)
    },
    /**
     * 「次へ」ボタンの使用可否を逆転する
     */
    toggleNextButtonDisabled() {
      this.nextButtonDisabled = !this.nextButtonDisabled;
    },
    /**
     * ご契約内容を取得する
     *
     * @param {object} params リクエストパラメーター
     */
    getServiceData(params) {
      // S21301_契約内容取得処理を実行
      S213ContractDetailsRepository.view(params)
        // 成功時
        .then((response) => {
          const apiData = response.data.data[0]

          // セットプラン
          // ライト
          if (typeof apiData.light_user !== 'undefined') {
            this.contract_info.light_user = apiData.light_user
            this.order_info.light_user = apiData.light_user
          }
          // スタンダード
          if (typeof apiData.standard_user !== 'undefined') {
            this.contract_info.standard_user = apiData.standard_user
            this.order_info.standard_user = apiData.standard_user
          }
          // プレミアム
          if (typeof apiData.premium_user !== 'undefined') {
            this.contract_info.premium_user = apiData.premium_user
            this.order_info.premium_user = apiData.premium_user
          }
          // チャットプラス
          if (typeof apiData.chatplus_user !== 'undefined') {
            this.contract_info.chatplus_user = apiData.chatplus_user
            this.order_info.chatplus_user = apiData.chatplus_user
          }

          if (typeof apiData.neo !== 'undefined') {
            // desknet's NEO ユーザー数
            if (typeof apiData.neo.neo_user !== 'undefined') {
              this.contract_info.neo.neo_user = apiData.neo.neo_user
              this.order_info.neo.neo_user = apiData.neo.neo_user
            }

            // AppSuite ユーザー数
            if (typeof apiData.neo.app_suite_user !== 'undefined' || typeof apiData.neo.app_suite_user_old !== 'undefined') {
              // （価格改定後）
              if (typeof apiData.neo.app_suite_user !== 'undefined') {
                this.contract_info.neo.app_suite_user = apiData.neo.app_suite_user
                this.order_info.neo.app_suite_user = apiData.neo.app_suite_user
              }
              // （価格改定前）
              if (typeof apiData.neo.app_suite_user_old !== 'undefined') {
                this.contract_info.neo.app_suite_user_old = apiData.neo.app_suite_user_old
                this.order_info.neo.app_suite_user_old = apiData.neo.app_suite_user_old
              }
              // ラジオボタンの初期値を変更
              this.selected_radio_list.app_suite = '1'
            }

            // desknet's NEO ウェブ会議 会議室の数
            if (typeof apiData.neo.web_conferencing !== 'undefined') {
              this.contract_info.neo.web_conferencing = apiData.neo.web_conferencing
              this.order_info.neo.web_conferencing = apiData.neo.web_conferencing
              // ラジオボタンの初期値を変更
              this.selected_radio_list.web_conferencing = '1'
            }

            // desknet's DB ユーザー数
            if (typeof apiData.neo.cloud_db_user !== 'undefined') {
              this.contract_info.neo.cloud_db_user = apiData.neo.cloud_db_user
              this.order_info.neo.cloud_db_user = apiData.neo.cloud_db_user
            }

            // オプションサービス
            if (typeof apiData.neo.option !== 'undefined') {
              let option = apiData.neo.option
              // RoomMgr
              if (typeof option.room_mgr !== 'undefined') {
                this.contract_info.neo.option.room_mgr = option.room_mgr
                this.contract_info.neo.option.room_mgr = option.room_mgr
                // ラジオボタンの初期値を変更
                this.selected_radio_list.room_mgr = '2'
              }

              // 交通費・経費精算
              if (typeof option.expense_settlement !== 'undefined') {
                this.contract_info.neo.option.expense_settlement = option.expense_settlement
                this.contract_info.neo.option.expense_settlement = option.expense_settlement
                // ラジオボタンの初期値を変更
                this.selected_radio_list.expense_settlement = '2'
              }

              // タイムカード＋CLOUZA
              if (typeof option.clouza !== 'undefined') {
                this.contract_info.neo.option.clouza.user = option.clouza.user
                this.order_info.neo.option.clouza.user = option.clouza.user
                // 会社コード
                if (option.clouza.clouza_company !== null) {
                  this.contract_info.neo.option.clouza.clouza_company = option.clouza.clouza_company
                  this.order_info.neo.option.clouza.clouza_company = option.clouza.clouza_company
                }
                // 有休管理＋申請承認オプション
                if (typeof option.clouza.paid_leave_option !== 'undefined') {
                  this.contract_info.neo.option.clouza.paid_leave_option = option.clouza.paid_leave_option
                  this.order_info.neo.option.clouza.paid_leave_option = option.clouza.paid_leave_option
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.clouza = '1'
              }

              // ディスク増設
              if (typeof option.disk !== 'undefined') {
                // （価格改定後）
                if (typeof option.disk.disk_size !== 'undefined') {
                  this.contract_info.neo.option.disk.disk_size = option.disk.disk_size
                  this.order_info.neo.option.disk.disk_size = option.disk.disk_size
                }
                // （価格改定前）
                if (typeof option.disk.disk_size_old !== 'undefined') {
                  this.contract_info.neo.option.disk.disk_size_old = option.disk.disk_size_old
                  this.order_info.neo.option.disk.disk_size_old = option.disk.disk_size_old
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.disk_size = '1'
              }

              // Sync for smartphones
              if (typeof option.sync !== 'undefined') {
                this.contract_info.neo.option.sync.user = option.sync.user
                this.order_info.neo.option.sync.user = option.sync.user
                // ラジオボタンの初期値を変更
                this.selected_radio_list.sync = '1'
              }

              // desknet'sドライブ ディスク増設
              if (typeof option.dn_drive !== 'undefined') {
                this.contract_info.neo.option.dn_drive.disk_size = option.dn_drive.disk_size
                this.order_info.neo.option.dn_drive.disk_size = option.dn_drive.disk_size
                // ラジオボタンの初期値を変更
                this.selected_radio_list.dn_drive = '1'
              }
            }

            // セキュリティオプション
            if (typeof apiData.neo.security !== 'undefined') {
              let security = apiData.neo.security
              // BASIC認証
              if (typeof security.basic !== 'undefined') {
                // ユーザーID
                this.contract_info.neo.security.basic.basic_id = security.basic.basic_id
                this.order_info.neo.security.basic.basic_id = security.basic.basic_id
                // パスワード
                this.contract_info.neo.security.basic.basic_password = security.basic.basic_password
                this.order_info.neo.security.basic.basic_password = security.basic.basic_password
                // 認証を除外するIPアドレスが存在する場合
                if (security.basic.basic_except_ip !== null) {
                  this.contract_info.neo.security.basic.basic_except_ip = security.basic.basic_except_ip
                  this.order_info.neo.security.basic.basic_except_ip = security.basic.basic_except_ip
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.basic = '1'
              }

              // 接続元IPアドレス制限
              if (typeof security.connect_permit_ip !== 'undefined') {
                this.contract_info.neo.security.connect_permit_ip = security.connect_permit_ip
                this.order_info.neo.security.connect_permit_ip = security.connect_permit_ip
                // ラジオボタンの初期値を変更
                this.selected_radio_list.connect_permit_ip = '1'
              }

              // クライアント認証
              if (typeof security.client !== 'undefined') {
                // デバイス数
                this.contract_info.neo.security.client.device = security.client.device
                this.order_info.neo.security.client.device = security.client.device
                // 認証を除外するIPアドレスが存在する場合
                if (security.client.cert_except_ip !== null) {
                  // 接続を許可するIPアドレス
                  this.contract_info.neo.security.client.cert_except_ip = security.client.cert_except_ip
                  this.order_info.neo.security.client.cert_except_ip = security.client.cert_except_ip
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.client = '1'
              }

              // セキュアブラウザ
              if (typeof security.secure !== 'undefined') {
                // セキュアブラウザ端末認証の値
                this.contract_info.neo.security.secure.secure_browser_terminal = security.secure.secure_browser_terminal
                this.order_info.neo.security.secure.secure_browser_terminal = security.secure.secure_browser_terminal
                // 「端末認証あり」の場合
                if (this.contract_info.neo.security.secure.secure_browser_terminal === '02') {
                  // デバイス数を設定する
                  this.contract_info.neo.security.secure.secure_browser_device = security.secure.secure_browser_device
                  this.order_info.neo.security.secure.secure_browser_device = security.secure.secure_browser_device
                  // 証明書操作のラジオボタンを設定
                  this.contract_info.neo.security.secure.secure_browser_certificate_action = '04'
                  this.order_info.neo.security.secure.secure_browser_certificate_action = '04'
                }
                // 認証を除外するIPアドレスが存在する場合
                if (security.secure.secure_except_ip !== null) {
                  // セキュアブラウザを適用しないIPアドレス
                  this.contract_info.neo.security.secure.secure_except_ip = security.secure.secure_except_ip
                  this.order_info.neo.security.secure.secure_except_ip = security.secure.secure_except_ip
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.secure = '1'
              }
            }

            // メールサービス
            if (typeof apiData.neo.mail !== 'undefined') {
              let mail = apiData.neo.mail
              // WebARENA
              if (typeof mail.arena !== 'undefined') {
                // 利用ドメイン名
                this.contract_info.neo.mail.arena.wa_domain = mail.arena.wa_domain
                this.order_info.neo.mail.arena.wa_domain = mail.arena.wa_domain
                // アカウント数
                this.contract_info.neo.mail.arena.account = mail.arena.account
                this.order_info.neo.mail.arena.account = mail.arena.account
                // ラジオボタンの初期値を変更
                this.selected_radio_list.arena = '1'
              }

              // CYBERMAILΣ
              if (typeof mail.cyber !== 'undefined') {
                // CYBERMAILΣアカウント数
                this.contract_info.neo.mail.cyber.account = mail.cyber.account
                this.order_info.neo.mail.cyber.account = mail.cyber.account
                // メールボックス容量のフラグ値
                this.contract_info.neo.mail.cyber.mailbox = mail.cyber.mailbox
                this.order_info.neo.mail.cyber.mailbox = mail.cyber.mailbox
                // CYBERMAILΣオプション
                if (typeof mail.cyber.options !== 'undefined') {
                  this.contract_info.neo.mail.cyber.options = mail.cyber.options
                  this.order_info.neo.mail.cyber.options = mail.cyber.options
                }
                // メール保存期間の値から表示用データを作成
                if (typeof mail.cyber.keep !== 'undefined') {
                  this.contract_info.neo.mail.cyber.keep = mail.cyber.keep
                  this.order_info.neo.mail.cyber.keep = mail.cyber.keep
                  // 10年保存を契約している場合
                  if (mail.cyber.keep === '03') {
                    // メールアーカイブ&監査のオプション選択肢に10年保存を追加
                    this.cyber_mail_achieve_option.push({ value: '03', name: '10年保存' })
                  }
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.cyber = '1'
                // Nヶ月後の日付選択をセット
                this.common_info.offset_date_list = mail.cyber.offset_date_list
              }
            }

            // メールセキュリティサービス
            if (typeof apiData.neo.mail_security !== 'undefined') {
              let mail_security = apiData.neo.mail_security
              // MAILGATES Σ
              if (typeof mail_security.mailgates !== 'undefined') {
                // 利用ドメイン名
                this.contract_info.neo.mail_security.mailgates.mailgates_domain = mail_security.mailgates.mailgates_domain
                this.order_info.neo.mail_security.mailgates.mailgates_domain = mail_security.mailgates.mailgates_domain
                // MAILGATESアカウント数
                this.contract_info.neo.mail_security.mailgates.account = mail_security.mailgates.account
                this.order_info.neo.mail_security.mailgates.account = mail_security.mailgates.account
                // MAILGATESオプション
                if (typeof mail_security.mailgates.options !== 'undefined') {
                  this.contract_info.neo.mail_security.mailgates.options = mail_security.mailgates.options
                  this.order_info.neo.mail_security.mailgates.options = mail_security.mailgates.options
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.mailgates = '1'
              }
            }
          }
          // ChatLuck
          if (typeof apiData.chat !== 'undefined') {
            // ChatLuck ユーザー数
            if (typeof apiData.chat.chat_user !== 'undefined') {
              // ChatLuck ユーザー数
              this.contract_info.chat.chat_user = apiData.chat.chat_user;
              this.order_info.chat.chat_user = apiData.chat.chat_user;
            }
            // オプションサービスがある場合
            if (typeof apiData.chat.option !== 'undefined') {
              let option = apiData.chat.option
              // ChatLuck 追加ディスク容量
              if (typeof option.disk !== 'undefined') {
                // 増設容量
                this.contract_info.chat.option.disk.disk_size = apiData.chat.option.disk.disk_size
                this.order_info.chat.option.disk.disk_size = apiData.chat.option.disk.disk_size
                // ラジオボタンの初期値を変更
                this.selected_radio_list.chat_disk_size = '1'
              }
            }

            // セキュリティオプションがある場合
            if (typeof apiData.chat.security !== 'undefined') {
              let security = apiData.chat.security
              // BASIC認証
              if (typeof security.basic !== 'undefined') {
                // ユーザーID
                this.contract_info.chat.security.basic.basic_id = security.basic.basic_id
                this.order_info.chat.security.basic.basic_id = security.basic.basic_id
                // パスワード
                this.contract_info.chat.security.basic.basic_password = security.basic.basic_password
                this.order_info.chat.security.basic.basic_password = security.basic.basic_password
                // 認証を除外するIPアドレスが存在する場合
                if (security.basic.basic_except_ip !== null) {
                  // 除外IPアドレス
                  this.contract_info.chat.security.basic.basic_except_ip = security.basic.basic_except_ip
                  this.order_info.chat.security.basic.basic_except_ip = security.basic.basic_except_ip
                }
                // ラジオボタンの初期値を変更
                this.selected_radio_list.chat_basic = '1'
              }

              // 接続元IPアドレス制限
              if (typeof security.connect_permit_ip !== 'undefined') {
                // 接続許可IPアドレス
                this.contract_info.chat.security.connect_permit_ip = security.connect_permit_ip
                this.order_info.chat.security.connect_permit_ip = security.connect_permit_ip
                // ラジオボタンの初期値を変更
                this.selected_radio_list.chat_connect_permit_ip = '1'
              }
            }
          }
        })
        .catch((error) => {
          console.log(error)
          // 共通のエラー処理
          this.apiError(error, '画面表示処理', 'Support')

          // 画面TOPまでスクロールをする
          this.pageTopScroll()
        })
        .finally(() => {
          // 読み込み完了
          this.isLoading = false
        })
    },
    /**
     * ご契約内容変更確認処理
     */
    checkOrder() {
      // ボタンをdisabledにする
      this.nextButtonDisabled = true
      // エラー時のスクロール先をリセット
      this.error_scroll_position = 99;
      // 表示されているエラーの消去
      this.resetErrorMsg()
      // リクエストパラメータを作成する
      let params = this.createRequestParameter()
      // API呼び出し
      S213ContractChangesRepository.check(params)
        // 成功時
        .then(() => {
          // ご契約変更内容確認画面へ遷移する
          // 画面パラメータに契約番号を設定
          this.$router.push({
            name: 'ConfirmChanges'
          })
        })
        // 失敗時
        .catch((err) => {
          // 共通のエラー処理
          this.apiError(err, '登録処理', 'Support')

          // レスポンスデータがある場合
          if (err.response !== null && typeof err.response !== 'undefined') {
            // httpステータスコードが403の場合（権限エラー）
            if (err.response.status === 403) {
              // 画面上部にエラーメッセージを表示する
              this.error_msg_list.top.push(this.forbidden_message);

              // 画面一番上へスクロールをする
              this.pageTopScroll();
            }

            // エラーメッセージがある場合
            if (err.response.data.error_list !== null && typeof err.response.data.error_list !== 'undefined') {
              // エラー要素の取得
              const errList = err.response.data.error_list.error ?? err.response.data.error_list
              // 各要素のエラーメッセージを出力する
              errList.forEach((objErr) => {
                let target = objErr.target
                let errorMsg = objErr.error_msg
                this.responseErrorMessage(target, errorMsg)
              })
              // エラーが出てる場所までスクロール
              this.scrollErrorPosition()
            }
          }
        })
        .finally(() => {
          // ボタンのdisabledを解除する
          this.nextButtonDisabled = false
        })
    },
    /**
     * エラーメッセージ要素を空にする
     *
     * @return {void}
     */
    resetErrorMsg() {
      // エラーメッセージリスト内のエラーメッセージを全てリセット
      Object.keys(this.error_msg_list).forEach((key) => {
        this.error_msg_list[key] = []
      })
    },
    /**
     * リクエストパラメータを作成する
     *
     * @return {object} リクエストパラメータ
     */
    createRequestParameter() {
      // 設定する変更対象製品の初期化
      let arTargetProduct = []

      // 変更フラグを見て、変更対象か決める
      // プラン変更
      if (this.show_plan === true) {
        // 変更対象製品にプランを追加
        arTargetProduct.push({ name: this.plan_info.name, order_type: this.selected_radio_list.plan })
      }
      // AppSuite
      if (this.show_app_suite === true) {
        // 変更対象製品にAppSuiteを追加
        arTargetProduct.push({ name: 'neo.' + this.app_suite_kind, order_type: this.selected_radio_list.app_suite })
      }
      // Web会議
      if (this.show_web_conferencing === true) {
        // 変更対象製品にWeb会議を追加
        arTargetProduct.push({ name: 'neo.web_conferencing', order_type: this.selected_radio_list.web_conferencing })
      }
      // RoomMgr
      if (this.show_room_mgr === true) {
        // 変更対象製品にRoomMgrを追加
        arTargetProduct.push({ name: 'neo.option.room_mgr', order_type: this.selected_radio_list.room_mgr })
        // 注文のステータスをtrueにする（変更する場合は必ずtrueのため）
        this.order_info.neo.option.room_mgr = true
      }
      // 交通費・経費精算
      if (this.show_expense_settlement === true) {
        // 変更対象製品に交通費・経費精算を追加
        arTargetProduct.push({ name: 'neo.option.expense_settlement', order_type: this.selected_radio_list.expense_settlement })
        // 注文のステータスをtrueにする（変更する場合は必ずtrueのため）
        this.order_info.neo.option.expense_settlement = true
      }
      // CLOUZA
      if (this.show_clouza === true) {
        // 変更対象製品にCLOUZAを追加
        arTargetProduct.push({ name: 'neo.option.clouza', order_type: this.selected_radio_list.clouza })
      }
      // ディスク増設
      if (this.show_neo_disk_size === true) {
        // 変更対象製品にディスク増設を追加
        arTargetProduct.push({ name: 'neo.option.disk.' + this.neo_disk_size_kind, order_type: this.selected_radio_list.disk_size })
      }
      // Sync for smartphone
      if (this.show_sync === true) {
        // 変更対象製品にSync for smartphoneを追加
        arTargetProduct.push({ name: 'neo.option.sync', order_type: this.selected_radio_list.sync })
      }
      // desknet'sドライブ ディスク増設
      if (this.show_dndrive_disk_size === true) {
        // 変更対象製品にdesknet'sドライブ ディスク増設を追加
        arTargetProduct.push({ name: 'neo.option.dn_drive', order_type: this.selected_radio_list.dn_drive })
      }
      // BASIC認証
      if (this.show_neo_basic === true) {
        // 変更対象製品にBASIC認証を追加
        arTargetProduct.push({ name: 'neo.security.basic', order_type: this.selected_radio_list.basic })
      }
      // 接続元IPアドレス制限
      if (this.show_neo_connect_permit === true) {
        // 変更対象製品に接続元IPアドレス制限を追加
        arTargetProduct.push({ name: 'neo.security.connect_permit_ip', order_type: this.selected_radio_list.connect_permit_ip })
      }
      // クライアント認証
      if (this.show_client === true) {
        // 変更対象製品にクライアント認証を追加
        arTargetProduct.push({ name: 'neo.security.client', order_type: this.selected_radio_list.client })
      }
      // セキュアブラウザ
      if (this.show_secure === true) {
        // 変更対象製品にセキュアブラウザを追加
        arTargetProduct.push({ name: 'neo.security.secure', order_type: this.selected_radio_list.secure })
        // デバイス数が設定されている場合
        if (this.contract_info.neo.security.secure.secure_browser_device !== '') {
          // 注文情報に変更前デバイス数を追加（セキュアブラウザのみの動作）
          this.order_info.neo.security.secure.now_secure_browser_device = this.contract_info.neo.security.secure.secure_browser_device
        }
        // 上記以外の場合
        else {
          // 0を設定
          this.order_info.neo.security.secure.now_secure_browser_device = '0'
        }
      }
      // WebARENA
      if (this.show_arena === true) {
        // 変更対象製品にWebARENAを追加
        arTargetProduct.push({ name: 'neo.mail.arena', order_type: this.selected_radio_list.arena })
      }
      // CYBERMAILΣ
      if (this.show_cyber === true) {
        // 変更対象製品にCYBERMAILΣを追加
        arTargetProduct.push({ name: 'neo.mail.cyber', order_type: this.selected_radio_list.cyber })
      }
      // MAILGATESΣ
      if (this.show_mailgates === true) {
        // 変更対象製品にMAILGATESΣを追加
        arTargetProduct.push({ name: 'neo.mail_security.mailgates', order_type: this.selected_radio_list.mailgates })
      }
      // ChatLuck
      if (this.show_chat === true) {
        // 変更対象製品にChatLuckを追加
        arTargetProduct.push({ name: 'chat.chat_user', order_type: this.selected_radio_list.chat_user })
      }
      // ChatLuckディスク増設
      if (this.show_chat_disk_size === true) {
        // 変更対象製品にChatLuckディスク増設を追加
        arTargetProduct.push({ name: 'chat.option.disk.disk_size', order_type: this.selected_radio_list.chat_disk_size })
      }
      // ChatLuck BASIC認証
      if (this.show_chat_basic === true) {
        // 変更対象製品にChatLuck BASIC認証を追加
        arTargetProduct.push({ name: 'chat.security.basic', order_type: this.selected_radio_list.chat_basic })
      }
      // ChatLuck 接続元IPアドレス制限
      if (this.show_chat_connect_permit === true) {
        // 変更対象製品にChatLuck 接続元IPアドレス制限を追加
        arTargetProduct.push({ name: 'chat.security.connect_permit_ip', order_type: this.selected_radio_list.chat_connect_permit_ip })
      }

      // 生成した変更対象製品を設定
      this.common_info.target_product = arTargetProduct

      // リクエストパラメータを返す
      return {
        contract_no: this.common_info.contract_no,
        data: this.order_info,
        target_product: this.common_info.target_product,
        opening_date: this.common_info.opening_date,
        estimate_no: this.common_info.estimate_no,
        order_remarks: this.common_info.order_remarks,
        // サービス利用約款など
        provision_check: this.provision_check.checked === true ? '1' : '0'
      }
    },
    /**
     * エラーメッセージを追加する
     */
    responseErrorMessage(target, msg) {
      // アンカー位置を取得
      let anchor_position = this.getAnchorPos(target)
      // アンカー位置を更新
      if (this.compareAnchor(this.error_scroll_position, anchor_position) === true) {
        this.error_scroll_position = anchor_position
      }

      switch (target) {
        //------------------------------
        // 各項目のエラーメッセージ
        //------------------------------
        // desknet's NEO
        case 'neo_user':
          // エラーメッセージを追加する
          this.error_msg_list.plan.push(msg)
          break
        // ライト
        case 'light_user':
          // エラーメッセージを追加する
          this.error_msg_list.plan.push(msg)
          break
        // スタンダード
        case 'standard_user':
          // エラーメッセージを追加する
          this.error_msg_list.plan.push(msg)
          break
        // プレミアム
        case 'premium_user':
          // エラーメッセージを追加する
          this.error_msg_list.plan.push(msg)
          break
        // チャットプラス
        case 'chatplus_user':
          // エラーメッセージを追加する
          this.error_msg_list.plan.push(msg)
          break
        // 業務アプリ作成ツールAppSuite
        case 'app_suite_user':
          this.error_msg_list.app_suite.push(msg)
          break
        // AppSuite（価格改定前）
        case 'app_suite_user_old':
          // エラーメッセージを追加する
          this.error_msg_list.app_suite.push(msg)
          break
        // desknet's ウェブ会議
        case 'web_conferencing':
          this.error_msg_list.web_conferencing.push(msg)
          break
        // RoomMgrチェックボックス
        case 'option_room_mgr':
          this.error_msg_list.room_mgr.push(msg)
          break
        // 交通費・経費精算チェックボックス
        case 'option_expense_settlement':
          this.error_msg_list.expense_settlement.push(msg)
          break
        // タイムカード＋CLOUZAユーザー数
        case 'clouza_input':
          this.error_msg_list.clouza_user.push(msg)
          break
        // タイムカード＋CLOUZA会社コード
        case 'clouza_company_code':
          this.error_msg_list.clouza_company.push(msg)
          break
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        case 'paid_leave_option':
          this.error_msg_list.clouza_paid_leave.push(msg)
          break
        // ディスク増設
        case 'option_disk_size':
          this.error_msg_list.disk_size.push(msg)
          break
        // ディスク増設（価格改定前）
        case 'option_disk_size_old':
          this.error_msg_list.disk_size.push(msg)
          break
        // Sync for smartphones
        case 'option_sync_input':
          this.error_msg_list.sync_user.push(msg)
          break
        // dnドライブ
        case 'option_dn_drive_disk_size':
          this.error_msg_list.dn_drive_disk_size.push(msg)
          break
        // BASIC認証ユーザーID
        case 'neo_basic_auth_user':
          this.error_msg_list.basic_id.push(msg)
          break
        // BASIC認証パスワード
        case 'neo_basic_auth_password':
          this.error_msg_list.basic_password.push(msg)
          break
        // BASIC認証認証を除外するIPアドレス
        case 'neo_basic_except_ip':
          this.error_msg_list.basic_except_ip.push(msg)
          break
        // 接続を許可するIPアドレス
        case 'neo_connect_permit_ip':
          this.error_msg_list.connect_permit_ip.push(msg)
          break
        // セキュアブラウザ端末認証
        case 'secure_browser_terminal':
          this.error_msg_list.secure_terminal.push(msg)
          break
        // セキュアブラウザ証明書アクション
        case 'secure_browser_certificate_action':
          this.error_msg_list.secure_certificate_action.push(msg)
          break
        // セキュアブラウザデバイス数
        case 'secure_browser_device':
          this.error_msg_list.secure_device.push(msg)
          break
        // 再発行する証明書
        case 'secure_browser_re_create':
          this.error_msg_list.secure_re_certificate.push(msg)
          break
        // 削減する証明書
        case 'secure_browser_delete_certificate':
          this.error_msg_list.secure_delete_certificate.push(msg)
          break;
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        case 'secure_browser_ip':
          this.error_msg_list.secure_except_ip.push(msg)
          break
        // クライアント認証デバイス数
        case 'client_auth_input':
          this.error_msg_list.client_device.push(msg)
          break
        // クライアント認証認証を除外するIPアドレス
        case 'client_auth_ip':
          this.error_msg_list.client_except_ip.push(msg)
          break
        // WebARENA利用ドメイン名
        case 'web_arena_domain':
          this.error_msg_list.arena_domain.push(msg)
          break
        // WebARENAアカウント数
        case 'web_arena_input':
          this.error_msg_list.arena_account.push(msg)
          break
        // CYBERMAILΣアカウント数
        case 'cyber_input':
          this.error_msg_list.cyber_account.push(msg)
          break
        // CYBERMAILΣメールボックス容量
        case 'cyber_capacity':
          this.error_msg_list.cyber_mailbox.push(msg)
          break
        // CYBERMAILΣオプション
        case 'cyber_option':
          this.error_msg_list.cyber_option.push(msg)
          break
        // CYBERMAILΣメールアーカイブ＆監査保存期間
        case 'cyber_keep_period':
          this.error_msg_list.cyber_keep.push(msg)
          break
        // MAILGATES Σ利用ドメイン名
        case 'mailgates_domain':
          this.error_msg_list.mailgates_domain.push(msg)
          break
        // MAILGATES Σアカウント数
        case 'mailgates_input':
          this.error_msg_list.mailgates_account.push(msg)
          break
        // MAILGATES Σオプション
        case 'mailgates_option':
          this.error_msg_list.mailgates_option.push(msg)
          break
        // ChatLuck
        case 'chat_user':
          // エラーメッセージを追加する
          this.error_msg_list.chat_user.push(msg)
          break
        // ChatLuck ディスク増設増設容量
        case 'chat_option_disk_size':
         this.error_msg_list.chat_disk_size.push(msg)
          break
        // ChatLuck BASIC認証ユーザーID
        case 'chat_basic_auth_user':
          this.error_msg_list.chat_basic_id.push(msg)
          break
        // ChatLuck BASIC認証パスワード
        case 'chat_basic_auth_password':
          this.error_msg_list.chat_basic_password.push(msg)
          break
        // ChatLuck BASIC認証認証を除外するIPアドレス
        case 'chat_basic_except_ip':
          this.error_msg_list.chat_basic_except_ip.push(msg)
          break
        // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
        case 'chat_connect_permit_ip':
          this.error_msg_list.chat_connect_permit_ip.push(msg)
          break

        // desknet'sNEO組み合わせの該当箇所にエラーメッセージを追加
        // 「スタンダードプラン」 + 「AppSuite」
        case 'appsuite_standard':
          this.error_msg_list.plan.push(msg)
          this.error_msg_list.app_suite.push(msg)
          break
        // 「プレミアム」 + 「AppSuite」
        case 'appsuite_premium':
          this.error_msg_list.plan.push(msg)
          this.error_msg_list.app_suite.push(msg)
          break
        // 「タイムカード＋CLOUZA」 ＋ 「セキュアブラウザ」
        case 'clouza_secure':
          this.error_msg_list.clouza_select.push(msg)
          this.error_msg_list.secure_select.push(msg)
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'neo_basic_except_permit':
          this.error_msg_list.basic_select.push(msg)
          this.error_msg_list.connect_permit_ip_select.push(msg)
          break
        // 「BASIC認証」 ＋ 「クライアント認証」
        case 'neo_basic_client':
          this.error_msg_list.basic_select.push(msg)
          this.error_msg_list.client_select.push(msg)
          break
        // 「BASIC認証」 ＋ 「セキュアブラウザ」の「端末認証あり」
        case 'neo_basic_secure_device':
          this.error_msg_list.basic_select.push(msg)
          this.error_msg_list.secure_terminal.push(msg)
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「セキュアブラウザ」の「端末認証なし」
        case 'neo_basic_except_secure_terminal':
          this.error_msg_list.basic_except_ip.push(msg)
          this.error_msg_list.secure_terminal.push(msg)
          break
        // 「接続元IPアドレス制限」 ＋ 「クライアント認証」
        case 'neo_permit_client':
          this.error_msg_list.connect_permit_ip_select.push(msg)
          this.error_msg_list.client_select.push(msg)
          break
        // 「接続元IPアドレス制限」 ＋ 「セキュアブラウザ」
        case 'neo_permit_secure':
          this.error_msg_list.connect_permit_ip_select.push(msg)
          this.error_msg_list.secure_select.push(msg)
          break
        // 「クライアント認証」 ＋ 「セキュアブラウザ」
        case 'client_secure':
          this.error_msg_list.client_select.push(msg)
          this.error_msg_list.secure_select.push(msg)
          break
        // CYBERMAILΣの「情報漏えい対策（有償）」+「添付ファイル暗号化・分離（有償）」
        case 'cyber_leak_encode':
          this.error_msg_list.cyber_option.push(msg)
          break
        // 「CYBERMAILΣ」＋「MAILGATES Σ」
        case 'cyber_mailgates':
          this.error_msg_list.cyber_select.push(msg)
          this.error_msg_list.mailgates_select.push(msg)
          break
        // 「MAILGATES Σ」の「誤送信対策・審査」 ＋ 「MAILGATES Σ」の「添付ファイル暗号化・分離」
        case 'prevent_missend_separation':
          this.error_msg_list.mailgates_option.push(msg)
          break
        // ChatLuck組み合わせの該当箇所にエラーメッセージを追加
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'chat_basic_except_permit':
          this.error_msg_list.chat_basic_except_ip.push(msg)
          this.error_msg_list.chat_connect_permit_ip_select.push(msg)
          break

        //------------------------------
        // 商品以外のエラーメッセージ
        //------------------------------
        // 変更希望日
        case 'opening_date':
          // エラーメッセージを追加する
          this.error_msg_list.preferred_date.push(msg)
          break;

        // お見積番号
        case 'estimate':
          // エラーメッセージを追加する
          this.error_msg_list.estimate_no.push(msg)
          break;

        // 備考
        case 'remarks':
          // エラーメッセージを追加する
          this.error_msg_list.remarks.push(msg)
          break;

        // サービス利用約款など
        case 'provision_check':
          // エラーメッセージを追加する
          this.error_msg_list.provision_check.push(msg)
          break;

        default:
          // エラーメッセージを追加する
          this.error_msg_list.top.push(msg)
          break;
      }
    },
    /**
     * エラーの箇所までスクロールさせる
     */
    scrollErrorPosition() {
      // アンカーが設定されている場合
      if (this.error_scroll_position !== '' && this.error_scroll_position !== 'other') {
        // アンカーの場所までスクロール
        document.getElementById(this.error_scroll_position).scrollIntoView();
      }
      // アンカーが設定されてない
      else {
        // 画面の一番上へ
        this.pageTopScroll();
      }
    },
    /**
     * アンカー位置を取得
     * @param {string} sTarget エラー項目
     */
    getAnchorPos(sTarget) {
      // エラーメッセージを表示させる位置を返す
      switch (sTarget) {
        // desknet's NEO
        case 'neo_user':
          return 'plan'
        // ライト
        case 'light_user':
          return 'plan'
        // スタンダード
        case 'standard_user':
          return 'plan'
        // プレミアム
        case 'premium_user':
          return 'plan'
        // チャットプラス
        case 'chatplus_user':
          return 'plan'
        // AppSuite（価格改定前）
        case 'app_suite_user_old':
          return 'option_service'
        // 業務アプリ作成ツールAppSuite
        case 'app_suite_user':
          return 'option_service'
        // desknet's ウェブ会議
        case 'web_conferencing':
          return 'option_service'
        // RoomMgrチェックボックス
        case 'option_room_mgr':
          return 'neo_option_service'
        // 交通費・経費精算チェックボックス
        case 'option_expense_settlement':
          return 'neo_option_service'
        // タイムカード＋CLOUZAユーザー数
        case 'clouza_input':
          return 'neo_option_service'
        // タイムカード＋CLOUZA会社コード
        case 'clouza_company_code':
          return 'neo_option_service'
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        case 'paid_leave_option':
          return 'neo_option_service'
        // ディスク増設
        case 'option_disk_size':
          return 'neo_option_service'
        // ディスク増設（価格改定前）
        case 'option_disk_size_old':
          return 'neo_option_service'
        // Sync for smartphones
        case 'option_sync_input':
          return 'neo_option_service'
        // desknet'sドライブ
        case 'option_dn_drive_disk_size':
          return 'neo_option_service'
        // BASIC認証ユーザーID
        case 'neo_basic_auth_user':
          return 'neo_security_option'
        // BASIC認証パスワード
        case 'neo_basic_auth_password':
          return 'neo_security_option'
        // BASIC認証認証を除外するIPアドレス
        case 'neo_basic_except_ip':
          return 'neo_security_option'
        // 接続を許可するIPアドレス
        case 'neo_connect_permit_ip':
          return 'neo_security_option'
        // セキュアブラウザ端末認証
        case 'secure_browser_terminal':
          return 'neo_security_option'
        // セキュアブラウザデバイス数
        case 'secure_browser_device':
          return 'neo_security_option'
        // 再発行する証明書
        case 'secure_browser_re_create':
          return 'neo_security_option'
        // 削減する証明書
        case 'secure_browser_delete_certificate':
          return 'neo_security_option'
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        case 'secure_browser_ip':
          return 'neo_security_option'
        // クライアント認証デバイス数
        case 'client_auth_input':
          return 'neo_security_option'
        // クライアント認証認証を除外するIPアドレス
        case 'client_auth_ip':
          return 'neo_security_option'
        // メールサービス チェックボックス
        case 'mail_service':
          break
        // WebARENA
        case 'web_arena':
          return 'neo_mail_service'
        // WebARENA利用ドメイン名
        case 'web_arena_domain':
          return 'neo_mail_service'
        // WebARENAアカウント数
        case 'web_arena_input':
          return 'neo_mail_service'
        // CYBERMAILΣアカウント数
        case 'cyber_input':
          return 'neo_mail_service'
        // CYBERMAILΣメールボックス容量
        case 'cyber_capacity':
          return 'neo_mail_service'
        // CYBERMAILΣオプション
        case 'cyber_option':
          return 'neo_mail_service'
        // CYBERMAILΣメールアーカイブ＆監査保存期間
        case 'cyber_keep_period':
          return 'neo_mail_service'
        // MAILGATES Σ利用ドメイン名
        case 'mailgates_domain':
          return 'neo_mail_security_service'
        // MAILGATES Σアカウント数
        case 'mailgates_input':
          return 'neo_mail_security_service'
        // MAILGATES Σオプション
        case 'mailgates_option':
          return 'neo_mail_security_service'
        // ChatLuck
        case 'chat_user':
          return 'chat'
        // ChatLuck ディスク増設増設容量
        case 'chat_option_disk_size':
          return 'chat_option_service'
        // ChatLuck BASIC認証ユーザーID
        case 'chat_basic_auth_user':
          return 'chat_security_option'
        // ChatLuck BASIC認証パスワード
        case 'chat_basic_auth_password':
          return 'chat_security_option'
        // ChatLuck BASIC認証認証を除外するIPアドレス
        case 'chat_basic_except_ip':
          return 'chat_security_option'
        // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
        case 'chat_connect_permit_ip':
          return 'chat_security_option'
        // 「スタンダードプラン」 + 「AppSuite」
        case 'appsuite_standard':
          return 'option_service'
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'neo_basic_except_permit':
          return 'neo_security_option'
        // 「タイムカード＋CLOUZA」 ＋ 「セキュアブラウザ」
        case 'clouza_secure':
          return 'neo_option_service'
        // 「BASIC認証」 ＋ 「クライアント認証」
        case 'neo_basic_client':
          return 'neo_security_option'
        // 「BASIC認証」 ＋ 「セキュアブラウザ」の「端末認証あり」
        case 'neo_basic_secure_device':
          return 'neo_security_option'
        // 「BASIC認証」の「除外IPあり」 ＋ 「セキュアブラウザ」の「端末認証なし」
        case 'neo_basic_except_secure_terminal':
          return 'neo_security_option'
        // 「接続元IPアドレス制限」 ＋ 「クライアント認証」
        case 'neo_permit_client':
          return 'neo_security_option'
        // 「接続元IPアドレス制限」 ＋ 「セキュアブラウザ」
        case 'neo_permit_secure':
          return 'neo_security_option'
        // 「クライアント認証」 ＋ 「セキュアブラウザ」
        case 'client_secure':
          return 'neo_option_service'
        // CYBERMAILΣの「情報漏えい対策（有償）」+「添付ファイル暗号化・分離（有償）」
        case 'cyber_leak_encode':
          return 'neo_mail_service'
        // 「CYBERMAILΣ」＋「MAILGATES Σ」
        case 'cyber_mailgates':
          return 'neo_mail_service'
        // 「MAILGATES Σ」の「誤送信対策・審査」 ＋ 「MAILGATES Σ」の「添付ファイル暗号化・分離」
        case 'prevent_missend_separation':
          return 'neo_mail_security_service'
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'chat_basic_except_permit':
          return 'chat_security_option'
        // 変更希望日
        case 'opening_date':
          return 'preferred_date'
        // お見積番号
        case 'estimate':
          return 'estimate'
        // 備考
        case 'remarks':
          return 'remarks'
        // サービス利用約款など
        case 'provision_check':
          return 'service_terms'
        default:
          return 'other'
      }
    },
    /**
     * アンカー位置を更新
     *
     * @param {string} sCurrentAnchor 現在のアンカー位置
     * @param {string} sTargetAnchor  更新対象のアンカー位置
     * @return {boolean} true：アンカー位置を更新、false：アンカー位置は更新しない
     */
    compareAnchor(sCurrentAnchor, sTargetAnchor) {
      // アンカー位置の優先度で比較
      return this.getAnchorPriority(sCurrentAnchor) > this.getAnchorPriority(sTargetAnchor)
    },
    /**
     * アンカー位置の優先度を取得
     *
     * @param {string} sAnchorPosition アンカー位置
     * @return {int} 優先度
     */
    getAnchorPriority(sAnchorPosition) {
      // 配列を探索する
      for (let iIndex = 0; iIndex < this.arAnchorList.length; iIndex++) {
        // アンカー位置が見つかった場合
        if (this.arAnchorList[iIndex] === sAnchorPosition) {
          // 位置を優先度として返す
          return iIndex;
        }
      }

      // 見つからなかった場合は配列のサイズを優先度として返す
      return this.arAnchorList.length
    },
    /**
     * Nヶ月後の最終営業日選択プルダウン用のオプションを作成する
     * @params {array} arOffsetDateList Nヶ月後の日付リスト
     * @return {array}
     */
    setOffsetDateOptions(arOffsetDateList) {
      // プルダウンに表示するオプション配列を初期化
      let offset_date_options = [{ value: '', name: '（日付を選択してください）' }];

      // APIレスポンスで受け取ったNヶ月後の日付リストを順に処理
      arOffsetDateList.forEach((offset_date) => {
        // 日付文字列（YYYY-MM-DD）をハイフンごとに区切る
        const [year, month, day] = offset_date.split('-');
        // APIレスポンスで受け取ったNヶ月後の日付を選択値として設定し、「YYYY年MM月DD日」形式で名前を設定
        offset_date_options.push({
          value: offset_date,
          name: `${year}年${month}月${day}日`
        });
      });
      // 完成したオプション配列を設定
      return offset_date_options
    },
    /**
     * 変更希望日をリセットする
     * @return {void}
     */
    resetDate() {
      this.common_info.opening_date = '';
    },
    /**
     * 変更希望日の初期値をセットする
     * @return {void}
     */
    setInitDate() {
      // Nヶ月後の日付リストの一つ目の日付をセットする
      this.common_info.opening_date = this.common_info.offset_date_list[0]
    }
  }
}
</script>

<style scoped lang='scss'>
.plan-title-bg-color {
  background-color: #fceaee;

  .btn:not(:hover) {
    background-color: #ffffff;
  }
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.other-title-bg-color {
  background-color: #f7f7f7;
}
.border-plan {
  border-color: #eb6ea0 !important;
}
.label-font-size {
  font-size: 16px;
}
.white-space {
  white-space: pre-line;
}
.space-col-size {
  max-width: 90px;
}
.title-col-size {
  max-width: 160px;
}
.input-div-size {
  width: 600px;
}
.disk-form-class {
  width: 95px !important;
}
.date-size {
  width: 210px !important;
}
.un-contracted-icon:after {
  content: '未契約';
  background-color: #6c757d;
  color: #fff;
  font-size: 12px;
  min-width: 10px;
  padding: 5px 9px;
  margin: 0 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.contracted-icon:after {
  content: 'ご契約中';
  background-color: #28a745;
  color: #fff;
  font-size: 12px;
  min-width: 10px;
  padding: 5px 9px;
  margin: 0 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.detail-button {
  height: 22px;
  font-size: 11px;
  display: inline;
  align-items: center;
  margin-bottom: 30px !important;
}
.secure-device-description {
  margin-left: 128px;
  margin-top: 0px;
}
img {
  width: 100px;
  height: auto;
}
.estimate-size {
  width: 400px !important;
}
</style>
